import {
  AfterViewChecked, ChangeDetectorRef, Component, computed, effect,
  ElementRef, inject, Input, NgZone, OnDestroy, QueryList, signal, ViewChild, ViewChildren, OnInit, AfterViewInit,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BannerWidth, Spacing } from '@components/banner-wrapper';
import { Observable, Subscription } from 'rxjs/index';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { ConnectionService } from '@services/connection-service';
import { DoctorProfile } from '@cureskin/api-client-rn';
import { UserAllocatedDoctorService } from '@services/user-allocated-doctor-service/user-allocated-doctor.service';
import { DataStoreService } from '@services/data-store-service';
import { BroadcastService } from '@services/broadcast-service';
import { WindowRefService } from '@services/window-ref-service';
import { TimeService } from '@services/time-service';
import { EventLoggerService } from '@services/event-logger-service';
import { CommonUtilityHelper } from '@services/common-utility-helper/common-utility-helper';
import { ImageService } from '@services/image-service';
import { CurrentComponentService } from '@services/current-component';
import { AppStateI } from '@store/reducers';
import { fromSelectors } from '@store/selectors';
import { ApiClientConstant, ParseKeys, RequestQueryPayload, Table } from '@cureskin/api-client';
import { AppWebBridgeService } from '@services/app-web-bridge-service';
import SwiperCore, { Scrollbar, Autoplay, SwiperOptions, Pagination, Swiper } from 'swiper';
import { SwiperComponent } from 'swiper_angular';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { IncompleteChatSheetComponent } from '@shared/bottom-sheet-layouts/incomplete-chat/incomplete-chat-sheet.component';
import { FollowUpChatSheetComponent } from '@shared/bottom-sheet-layouts/followup-chat/followup-chat-sheet.component';
import { PrivacyPolicySheetComponent } from '@shared/bottom-sheet-layouts/privacy-policy/privacy-policy-sheet.component';
import { HomePageSheetComponent } from '@shared/bottom-sheet-layouts/homepage-bottom-sheet/home-page-bottom-sheet.component';
import { CureskinCashSheetComponent } from '@shared/bottom-sheet-layouts/cureskin-cash-sheet/cureskin-cash-sheet.component';
import { AnytimeFollowupComponent } from '@shared/bottom-sheet-layouts/anytime-followup/anytime-followup.component';
import { ActiveCheckupBottomsheetComponent } from 'client/app/user-checkup/active-checkup-bottomsheet/active-checkup-bottomsheet.component';
import { InstantCheckupService } from '@services/instant-checkup-service/instant-checkup.service';
import { LocalStorageService } from '@services/local-storage-service';
import { TakePhotoBannerService } from '@services/banner-services/take-photo-banner-service';
import { InstantCheckupHelper } from 'client/helper/instant-checkup-helper';
import { AppConfig } from '../../../app.config';
import { ElementTrackableDirective } from '@directives/element-trackable/element-trackable.directive';
import { ElementPositionService } from '@services/element-position-service/element-position.service';
import { RecommendedProductsService, RecommendedProductsData } from '@services/recommended-products-service';
import { CrossSellRegimenService } from '@services/cross-sell-regimen-service/cross-sell-regimen.service';
import { RegimenService } from '@services/regimen-service';
import { RecentlyViewedProductsService } from '@services/recently-viewed-products/recently-viewed-products.service';
import { RecentlyViewedItem, RecentlyViewedEnum } from '@shared/types/recently-viewed.types';
import * as fromActions from '@store/actions/app.actions';
import { ExperimentService } from '@services/experiment';
import { CrossSellRegimenExperiment, RecommendedProductsSurface } from '@services/experiment/experiment.service.types';
import { NutraPushBannerData } from './nutra-push/nutra-push-banner/nutra-push-banner.component';
import { ReAcquisitionBannerType, ReAcquisitionService } from '@services/re-acquisition-service/re-acquisition.service';
import {
  HomepageInfoCard,
  HomepageInfoCardsData,
  HomepageInfoCardType,
  RetentionRevampCardOverrides,
  RetentionRevampCardStyling,
} from '../../../../static-translations/treatment-content-translations';
import { LanguageService } from '@services/language-service/language.service';
import { RegimenExpiryBannerData, RegimenExpiryService } from "@services/regimen-expiry-service/regimen-expiry.service";
import { RegimenExpiryBottomsheetComponent } from '@shared/bottom-sheet-layouts/regimen-expiry-bottomsheet/regimen-expiry-bottomsheet.component';
import { ConsultationSessionService } from '@services/consultation-session-service';
import { LanguageBannerService, LanguageBannerContent } from '@shared/home-banners/language-banner/language-banner.service';
import { IncompleteChatClass, IncompleteChatBannerService } from '@shared/home-banners/incomplete-chat-rebranded/incomplete-chat-banner.service';
import { WeeklyJourneyType, WeeklyJourneyData } from '@shared/types/weekly-journey.types';
import { OrderHelper } from 'client/helper/order-helper';
import { OrderService } from '@services/order-service/order.service';
import { InvestigationStatusResponse, ProductUsageTrackingResponseData, ReorderKitDetail } from '@cureskin/api-client/src/server-api/api';
import { InvestigationSheetComponent } from '@shared/bottom-sheet-layouts/investigation-sheet/investigation-sheet.component';
import { resetCacheByName } from '@services/connection-service/cache-interceptor';
import { UserService } from '@services/user';
import { AllocatedRegimen, FollowUpReportType, MoneyBackGuaranteedExperimentVariant } from '../../../app-constant-types';
import { ORDER_DELIVERY_BANNER, DIET_BANNER_PAGE } from '../../../app.constants';
import { PRIMARY_CHANNELS } from '@services/event-logger-service/event-logger.constant';
import { CartService } from '@services/cart-service/cart.service';
import { SelfCheckupService, SelfCheckupWindowContext } from '@services/self-checkup-service';
import { FollowUpService } from '@services/followup-service';
import { GetMainUserPhotosRegimenClassEnum, InstantCheckup, RegimenClass } from '@cureskin/api-client/src/server-api';
import {
  CompleteProfileBanner,
  CompleteProfileClassContext,
  CompleteProfileDecision,
  CompleteProfilePosition,
  CompleteProfileSection,
  CompleteYourProfileService,
} from '@services/complete-your-profile-service';
import { RegimenReorderService } from '@services/regimen-reorder-service/regimen-reorder.service';
import { ShopService } from '@services/shop-service/shop.service';
import { ExploreService } from '@services/explore-service';
import { DietBannerService } from '@services/diet-banner-service/diet-banner.service';
import { PersonalisedPromotionsService } from '@services/personalised-promotions-service';
import { ScrollDepthPageName, ScrollDepthService } from '@services/scroll-depth-service/scroll-depth.service';

SwiperCore.use([Autoplay, Scrollbar, Pagination]);

@Component({
  selector: 'user-home',
  templateUrl: './user-home.html',
  styleUrls: ['./user-home.scss'],
  standalone: false,
  providers: [ScrollDepthService],
})
class UserHomeComponent implements OnDestroy, AfterViewChecked, OnInit, AfterViewInit {
  // Page-scoped: flushes the scroll_depth event when this component is destroyed.
  private readonly scrollDepth = inject(ScrollDepthService);
  private readonly languageBannerService = inject(LanguageBannerService);
  private readonly incompleteChatBannerService = inject(IncompleteChatBannerService);

  @ViewChildren(ElementTrackableDirective) trackableDirectives: QueryList<ElementTrackableDirective>;
  @ViewChild('swiperWrapper', { static: false }) swiper: SwiperComponent;
  @ViewChild('swiperWrapperOne', { static: false }) swiperOne: SwiperComponent;
  @ViewChild('swiperWrapperTwo', { static: false }) swiperTwo: SwiperComponent;
  static BannerOrder: Record<string, number> = {
    doctorOrder: 1,
    followUpReport: 2,
    cartItems: 3,
  };
  // Gamification banner position constants
  private static readonly GAMIFICATION_BANNER_POSITION_2_DAYS = '2Days';
  private static readonly GAMIFICATION_BANNER_POSITION_4_DAYS = '4days';
  private static readonly GAMIFICATION_BANNER_POSITION_5_DAYS_PLUS = '5Days+';
  isTabActive: boolean;
  @ViewChild('homePageContainer', { static: true }) homePageContainer: ElementRef;
  isAovSaleLive: boolean = false;
  isAOVActive: boolean = false;
  recommendedProducts: RecommendedProductsData = { products: [], displayType: '', shouldShow: false };
  readonly isRestockBannerVisible = signal<boolean>(true);
  readonly languageBannerContent = signal<LanguageBannerContent | null>(null);
  readonly incompleteChatRebrandedEventData = { isRebrandedV2: 'true' };
  readonly IncompleteChatClassEnum = GetMainUserPhotosRegimenClassEnum;
  readonly isIncompleteFaceChatRebranded = computed((): boolean => this.isIncompleteChatRebranded(GetMainUserPhotosRegimenClassEnum.FACE));
  readonly isIncompleteHairChatRebranded = computed((): boolean => this.isIncompleteChatRebranded(GetMainUserPhotosRegimenClassEnum.HAIR));
  readonly faceChatBannerWidth = computed((): BannerWidth => (this.isIncompleteFaceChatRebranded() ? BannerWidth.Inset : BannerWidth.Full));
  readonly hairChatBannerWidth = computed((): BannerWidth => (this.isIncompleteHairChatRebranded() ? BannerWidth.Inset : BannerWidth.Full));
  @Input('refresh')
  set refresh(isActive: boolean) {
    this.isTabActive = isActive;
    this.refreshComponent();
  }
  @Input('animation') animation: any;
  @Input('tabUpdates') tabUpdates: any;
  @Input('showNotificationEnablePopUp') showNotificationEnablePopUp: boolean;
  protected readonly BannerWidth = BannerWidth;
  protected readonly Spacing = Spacing;
  user: any;
  userAge: string;
  showFollowUp: boolean = false;
  saleBannerImage: any;
  aovBannerImage: any;
  cashDiscount: any;
  cart: any;
  cartItems: any = [];
  userStatus: any = { PAID: false, GOT_REGIMEN: false, NO_PHOTO: false };
  skinBannerIndex: number = -1;
  hairBannerIndex: number = -1;
  resetKitReadyBannerHeight: boolean = false;
  userName: string;
  userFirstName: string;
  toolbarIcons: Array<any> = [{
    clickId: 'bell_notification',
    name: this.appConfig.Toolbar.ICONS.NOTIFICATION,
    callback: (): void => this.notificationClickAction(),
  }, {
    clickId: 'cart_page',
    name: this.appConfig.Toolbar.ICONS.CART,
    callback: (): void => this.goToCart(),
    cartValue: null,
  }];
  isUnReadFollowUpReport: boolean;
  tipOfDay: any;
  isMenuOpen: boolean;
  tempCashBalance: any;
  isTicketAwaitingResponse: boolean;
  regimens: Array<AllocatedRegimen & { isPreparationTimePending?: boolean }> = [];
  order: any;
  faqs: any = {};
  experiments: any = [];
  bannersTop: Array<any> = [];
  remainingFollowUpDays: number;
  showGameBanner: boolean = false;
  bannersBottom: Array<any> = [];
  loading: boolean = true;
  latestUnBoughtRegimen: any = {};
  subscriptions: Array<Subscription> = [];
  isRegimenBeingPrepared: boolean;
  offerBanner: any = {};
  showUnBoughtRegimen: boolean = false;
  blogs$: Observable<object[]>;
  supportTicket: any;
  orderChat: any;
  notListenedVoiceMessage: any;
  userDoctor: DoctorProfile;
  reorderProducts$: Observable<object[]> = this.store.select(fromSelectors.selectHomePageReorderProducts);
  addOnProducts$: Observable<object[]> = this.store.select(fromSelectors.selectHomePageAddons);
  showClaimCashBanner: boolean;
  showAMKitBanner: boolean = false;
  redirectArticleId: string = '';
  articleBannerImage: string = '';
  showFullBanner: boolean = false;
  showDietBanner: boolean = false;
  isDoctorOrder: boolean = false;
  hasRecentlyDeliveredRegimen: boolean = false;
  allActiveOrders: any;
  isotretinoinConsentPendingOrder: any = null;
  isotretinoinPregnancyAnswered: boolean = false;
  private readonly SHOP_BANNER_BLOCK_DAYS: number = 3;
  private readonly COMPLETE_YOUR_PROFILE_BANNER_VISIBILITY_DAYS: number = 13;
  isBOGOSaleLive: boolean = false;
  isSaleLive: boolean = false;
  bannerImage: any;
  faceIconUrl: string = 'https://cdn.cureskin.com/app/img/female-face.png';
  bodyIconUrl: string = 'https://cdn.cureskin.com/app/img/female-body.png';
  hairIconUrl: string = 'https://cdn.cureskin.com/app/img/female-hair.png';
  showAlternativeColorForPouchImage: boolean = false;
  activeBannerIndex: number = 0;
  activeBannerIndexOne: number = 0;
  bannerContainer: Array<any> = [];
  bannerContainerOne: Array<any> = [];
  bannerContainerTwo: Array<any> = [];
  requestDataInTicket: boolean = false;
  replyInTicket: boolean = false;
  is2499Upsell: boolean = false;
  bottomSheetPriority: Array<string> = [];
  private destroyed = false;
  private bottomSheetTimer: ReturnType<typeof setTimeout> | null = null;
  pendingDiscomfortTicket: any;
  activeDiscomfortTicket: any;
  isDiscomfortBannerActive: boolean = false;
  isDiscomfortVoiceNoteBannerActive: boolean = false;
  showDiscomfortBanner: boolean = false;
  audioMessageInTicket: any;
  carouselConfig: SwiperOptions = {
    slidesPerView: 1,
    autoHeight: true,
    navigation: { prevEl: 'nonext', nextEl: 'nonext' },
    pagination: { el: '#main-swiper-pagination' },
    autoplay: { delay: 6000, disableOnInteraction: false },
    on: {
      slideChangeTransitionStart: (event:Swiper):any => {
        this.onSlideChange2(event);
      },
    },
  };
  orderBannerCarouselConfig: SwiperOptions = {
    slidesPerView: 1,
    autoHeight: true,
    navigation: { prevEl: 'nonext', nextEl: 'nonext' },
    pagination: { el: '#order-banner-pagination' },
    autoplay: { delay: 6000, disableOnInteraction: false },
    on: {
      slideChangeTransitionStart: (event:Swiper):any => {
        this.onSlideChange2(event);
      },
    },
  };
  regimenPreparationCarouselConfig: SwiperOptions = {
    slidesPerView: 1,
    autoHeight: true,
    navigation: { prevEl: 'nonext', nextEl: 'nonext' },
    pagination: { el: '#regimen-preparation-pagination' },
    autoplay: { delay: 6000, disableOnInteraction: false },
    on: {
      slideChangeTransitionStart: (event:Swiper):any => {
        this.onSlideChange2(event);
      },
    },
  };
  nutraCarouselConfig: SwiperOptions = {
    slidesPerView: 1,
    autoHeight: true,
    navigation: { prevEl: 'nonext', nextEl: 'nonext' },
    pagination: { el: '#nutra-pagination' },
    autoplay: { delay: 6000, disableOnInteraction: false },
    on: {
      slideChangeTransitionStart: (event:Swiper):any => {
        this.onSlideChange2(event);
      },
    },
  };
  isMainSwiperMounted: boolean = false;
  bottomCarouselConfig: SwiperOptions = {
    slidesPerView: 1,
    pagination: true,
    autoplay: { delay: 6000, disableOnInteraction: false },
  };
  reorderCarouselConfig: SwiperOptions = {
    slidesPerView: 1,
    pagination: {
      el: '#reorder-swiper-pagination',
      clickable: true,
      renderBullet: (index: number, className: string): string => `<span class="${className}"></span>`,
    },
    autoplay: true,
  };
  carouselConfigOrderStatus: SwiperOptions = {
    slidesPerView: 1,
    navigation: { prevEl: 'nonext', nextEl: 'nonext' },
    pagination: {
      el: '#swiper-pagination',
      clickable: true,
      renderBullet: (index: number, className: string): string => `<span class="${className}"></span>`,
    },
    autoplay: { delay: 6000, disableOnInteraction: false },
  };
  carouselConfigTwo: SwiperOptions = {
    slidesPerView: 1,
    autoHeight: true,
    navigation: { prevEl: 'nonext', nextEl: 'nonext' },
    pagination: true,
    autoplay: { delay: 1000, disableOnInteraction: false },
  };
  regimenDeliveredCarouselConfig: SwiperOptions = {
    slidesPerView: 1,
    autoHeight: true,
    navigation: { prevEl: 'nonext', nextEl: 'nonext' },
    pagination: { el: '#regimen-delivered-pagination' },
    autoplay: { delay: 6000, disableOnInteraction: false },
  };
  protected readonly followUp = this.followUpService.followUp;
  readonly canShowFollowupQuestionsWidget = signal<boolean>(false);
  isWeeklyJourneyExperiment: boolean = false;
  isJourneyCardOne: boolean = false;
  isWeekOne: boolean = false;
  isJourneyCardTwo: boolean = false;
  expectedDeliveryDate: { from?: Date, to?: Date } = {};
  deliveryIntervalInDays: number = 2;
  latestFaceRegimenDelivered: any;
  faceDisplayConcern: string;
  hairDisplayConcern: string;
  primaryConcern: string = '';
  otherConcerns: string = '';
  faceRegimenOrderPlaced: any = {};
  faceRegimenOrderDelivered: any = {};
  hairRegimenOrderDelivered: any = {};
  pendingCheckInCall: any;
  isJourneyCardThree: boolean = false;
  isJourneyCardFour: boolean = false;
  isWeekThreeJourneyCard: boolean = false;
  isWeekFourJourneyCard: boolean = false;
  trackingURL: any;
  latestPlacedRegimenOrder: any;
  userDrImage: any;
  unreadNotifications: boolean = false;
  carouselConfigOne: SwiperOptions = {
    slidesPerView: 1,
    autoHeight: true,
    navigation: { prevEl: 'nonext', nextEl: 'nonext' },
    pagination: false,
    loop: false,
    autoplay: { delay: 6000, disableOnInteraction: false },
  };

  carouselConfigWeeklyJourney: SwiperOptions = {
    slidesPerView: 'auto',
    navigation: { prevEl: 'nonext', nextEl: 'nonext' },
  };
  defaultDoctorImage: string;
  drOrderBannerHome: boolean = false;
  productAddedByScript: any;
  allocatedDoctor: DoctorProfile;

  followUpDoctor: DoctorProfile;
  showStickyBars$: boolean = false;
  showFollowupBanner$: boolean = false;
  showFollowupPopup: boolean = false;
  showOrderStatusBanner: boolean = false;
  showDeliveredBanner: boolean = false;
  consultationSession: any;
  followUpReport: any;
  latestOrder: any;
  regimensClass: string[];
  indexOfHairRegimen: any;
  indexOfFaceRegimen: any;
  totalCashBalance: any;
  showCashBalance: boolean;
  minimumCash: any;
  reportWaitingTime: string;
  regimenKit: string;
  selectedFollowUpBanner: 'followUpScheduled' | 'followUpScheduledInTwoDays' | 'followUpReadyWaitingForReport' | 'followUpWaitingForImage'
    | 'anyTimeFollowUpEnabled' | 'lastFollowUpSkipped' | 'followUpReportIsReady';
  feedback: any;
  concernClass: string;
  // Boost your regimen
  isBoostYourRegimenExperiment: boolean = false;
  voiceNoteByScript: boolean = false;
  productsInCart: any[] = [];
  cartProductQuantities: { [key: string]: number } = {}; // For Redux store sync
  recommendedItems: any[] = [];
  voiceMessageOrder: any;
  cartDiscount: number = 0;
  showOrderStatus: any;
  totalMRP: number = 0;
  totalSP: number = 0;
  isMultipleQuestionQuiz: boolean = false;
  reAcquisitionBannerType: 'reAcquisitionBannerReady' | 'reAcquisitionCheckupPending' | 'waitingForReAcquisitionCall'
    | 'reAcquisitionWaitingForPhoto' | 'missedReAcquisitionCall';
  showUpdatedPrivacyPopup: boolean = false;
  festivalDelayBannerEnabled: boolean = false;
  startTimer:number;
  isiOSDevice: boolean = false;
  voiceNoteBannerDetails: {
    voiceUrl?: string,
    message?:string,
    doctorDisplayImageURL?: string,
    doctorName?: string,
    regimenCoverImageUrl?: string,
    trackEventAudio?: {[key: string]: unknown} } = {};
  isRebrandingHomeIcon: boolean = false;
  isHairThinningCrossSellBanner: boolean = false;
  isHairFallCrossSellBanner: boolean = false;
  isHairFallCrossSellMaleBanner: boolean = false;
  isHairChatPending: boolean = false;
  hairChatId: string;
  faceChatId: string;
  isFaceChatPending: boolean = false;
  showSuggestedForYouBanner: boolean = false;
  private stickyBarsSubscribed: boolean = false;
  takePhotoBannerPositionBottom: boolean = true;
  newRegimenPricingExperiment: any;
  isRegimenExtraProductBannerVisible: boolean = false;
  latestUnDelivereRegimen: any;
  isTakePhotoBannerEligible: boolean = false;
  instantCheckups: Array<object> = [];
  completeProfileSections: CompleteProfileSection[] = [];
  completeProfileEventData: { completed: string[]; pending: string[] } = { completed: [], pending: [] };
  showCompleteYourProfileBanner: boolean = false;
  showRebrandedProfileBanner: boolean = false;
  rebrandedProfileCards: RegimenClass[] = [];
  private rebrandedProfilePosition: CompleteProfilePosition = CompleteProfilePosition.BOTTOM;
  private faceChatStartedAt: number | null = null;
  private hairChatStartedAt: number | null = null;
  takePhotoBannerTrigerringStates:Record<string, boolean> = {
    orderWaitingForImage: false,
    orderPlacedWithoutCheckup: false,
    firstRegimenWithoutCheckup: false,
  };
  userLanguage: string = this.appConfig.Shared.Languages.EN;
  activeTakePhotoBannerState: any;
  lastLevelBannerOrder: string[] = ['DIET', 'REFER'];

  // Add new swiper config for last level banners
  customCarouselConfig: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
      el: '.custom-pagination', // Changed this to match our new container
      clickable: true,
      type: 'bullets', // Explicitly specify bullets
      renderBullet: (index: number, className: string): string => `<span class="${className}"></span>`,
    },
  };

  submitDefaultAnswersCarouselConfig: SwiperOptions = {
    slidesPerView: 1,
    pagination: {
      el: '#submit-default-answers-swiper-pagination',
      clickable: true,
      renderBullet: (index: number, className: string): string => `<span class="${className}"></span>`,
    },
    autoplay: { delay: 6000, disableOnInteraction: false },
  };

  isDoctorVerifiedKit: boolean = false;
  regimen: any;
  showVoiceNoteBanner: boolean = false;
  private readonly registeredElements: Set<any> = new Set();
  shouldShowStickyWidget: boolean = false;
  showNewCrossRegimenBanner: boolean = false;
  latestActiveRegimen: any;
  isNewHelpUiExp: boolean = false;
  disableTwoWeekExpectationVoiceNoteExp: boolean = false;
  nutraBannerExperiment: boolean = false;
  nutraBannerExperimentVariantData : {[key: string]: any};
  nutraMargIdsVariantsData: any;
  nutraProductsInfo: {};
  nutraBannerData: any[];
  showNutraBanner: boolean = false;
  activeNutraBannerData: any;
  unpaidUserChatBotExperiment: boolean = false;
  unpaidUserChatBotVariant: any;
  recentlyViewedData: RecentlyViewedItem[] = [];
  shouldShowRecentlyViewedSection: boolean = false;
  recentlyViewedLocation = RecentlyViewedEnum.Location;
  private static readonly FOLLOW_UP_DOT_DAYS_THRESHOLD = 2;
  isNotificationPermissionEnabled: boolean = false;
  showNotificationBanner: boolean = false;
  selfCheckupPhotoExperiment: any;
  isWithinSelfCheckupWindow: boolean = false;
  selfCheckupWindowDetermined: boolean = false;
  selfCheckupDaysSinceLastDelivery: number | null = null;
  nutraPushExperiment: boolean = false;
  nutraPushExperimentVariantData: any;
  nutraPushBannerData: NutraPushBannerData;
  nutraPushBottomSheetData: { objectId: string };
  minimumAmountSpentFromReAcq: number = this.appConfig.Shared.User.MinimumAmountSpentFromReAcq;
  buyNowFlowExperiment: boolean = false;
  doctorDetails: { firstName: string; image: string, specialization: string };
  gridDisplayLanguage: string;
  bentoGridCards: HomepageInfoCard[] = [];
  homePageFullScreenModeOn: boolean = false;
  regimenExpiryExperiment: any;
  regimenExpiryBannerData: RegimenExpiryBannerData;
  showRegimenExpiryBanner: boolean = false;
  showRegimenExpiredBanner: boolean = false;
  regimenExpiredBannerData: { firstName: string, image: string };
  weeklyJourneyV2Experiment: boolean = false;
  weeklyJourneyVariant: {
    variant2?: boolean;
    weekVisibility?: {
      week0: boolean;
      week1: boolean;
      week2: boolean;
      week3: boolean;
      week4: boolean;
    };
  } = {
    variant2: false,
    weekVisibility: {
      week0: false,
      week1: false,
      week2: false,
      week3: false,
      week4: false,
    }
  };
  WeeklyJourneyType = WeeklyJourneyType;
  gamificationExperiment: {
    variant: {
      streakRewardAmount: number;
      tipLanguageStrings: Array<string>;
    },
  };
  todayProductUsageData: ProductUsageTrackingResponseData
  shouldShowGamification: boolean = false;
  shouldShowGamificationRewardBanner: boolean = false;
  showScratchCard: boolean = false;
  rewardData: { objectId: string; amount?: number; expireAt?: { iso?: string } } | null = null;
  userRewards: any[];

  regimenExpiryEventData: {
    regimenClass: string,
    redirectToFollowUp: string,
    daysToExpire: string,
  };

  isUnpaidUser: boolean = false;
  skipExecutionForUnpaidUser: boolean = false;
  paymentDropOffOrders: Table.Order[] = [];
  acqPaymentDropOffExperiment: boolean = false;
  //siganls
  private readonly userActiveOrders = signal<any[]>([]);
  cartScriptBannerHeaderExperiment: boolean = false;
  isCheckupBsHomepageExperimentEnabled: boolean = false;
  checkupBsHomepageVariant: { face?: boolean; hair?: boolean } = {};
  showRegimenReorderBanner: boolean = false;
  regimenReorderKitDetails: ReorderKitDetail[] = [];
  submitDefualtAnswersBannerItems: Array<{ consultation: Table.ConsultationSession; thumbnailUrl: string | null }> = [];
  showAcqShopBanner: boolean = false;
  showAcqShopProductsBanner: boolean = false;
  investigationStatus: InvestigationStatusResponse | null = null;
  crossSellRegimenExperiment: CrossSellRegimenExperiment;

  private readonly regimenReorderService = inject<RegimenReorderService>(RegimenReorderService);
  private readonly shopService = inject<ShopService>(ShopService);
  private readonly exploreService = inject<ExploreService>(ExploreService);
  private readonly dietBannerService = inject<DietBannerService>(DietBannerService);

  constructor(private readonly router: Router,
              private readonly conn: ConnectionService,
              private readonly dataStore: DataStoreService,
              private readonly broadcast: BroadcastService,
              private readonly window: WindowRefService,
              private readonly route: ActivatedRoute,
              public readonly timeService: TimeService,
              public eventLogger: EventLoggerService,
              public readonly appConfig: AppConfig,
              private readonly commonUtil: CommonUtilityHelper,
              public readonly imageService: ImageService,
              private readonly currentComponentService: CurrentComponentService,
              private readonly changeDetectorRef: ChangeDetectorRef,
              private readonly zone: NgZone,
              private readonly appWebBridgeService: AppWebBridgeService,
              private readonly windowRef: WindowRefService,
              private readonly store: Store<AppStateI>,
              private readonly bottomSheet: MatBottomSheet,
              private readonly localStorage: LocalStorageService,
              private readonly takePhotoBannerService: TakePhotoBannerService,
              private readonly instantCheckupHelper: InstantCheckupHelper,
              private readonly localStorageService: LocalStorageService,
              public elementPositionService: ElementPositionService,
              public readonly crossSellRegimenService: CrossSellRegimenService,
              private readonly regimenService: RegimenService,
              private readonly recommendedProductsService: RecommendedProductsService,
              private readonly recentlyViewedProductsService: RecentlyViewedProductsService,
              private readonly appBridge: AppWebBridgeService,
              private readonly experimentService: ExperimentService,
              public readonly reAcquisitionService: ReAcquisitionService,
              private readonly languageService: LanguageService,
              private readonly regimenExpiryService: RegimenExpiryService,
              private readonly consultationSessionService: ConsultationSessionService,
              private readonly orderHelper: OrderHelper,
              private readonly orderService: OrderService,
              private readonly userService: UserService,
              private readonly cartService: CartService,
              private readonly instantCheckupService: InstantCheckupService,
              private readonly completeYourProfileService: CompleteYourProfileService,
              private readonly selfCheckupService: SelfCheckupService,
              private readonly followUpService: FollowUpService,
              private readonly personalisedPromotionsService: PersonalisedPromotionsService,
              private readonly userAllocatedDoctorService: UserAllocatedDoctorService,
  ) {
    this.broadcast.on('HOMEPAGE_FULLSCREEN_MODE_ON').subscribe((): void => {
      this.homePageFullScreenModeOn = true;
    });
    this.broadcast.on('HOMEPAGE_FULLSCREEN_MODE_OFF').subscribe((): void => {
      this.homePageFullScreenModeOn = false;
    });
    this.currentComponentService.set(this);

    effect(async () => {
      const combinedOrders = this.userActiveOrders();
      if (combinedOrders.length > 0) {
        await this.validateAndRenderWeeklyJourneyCard();
        await this.getActiveAndCompletedOrders().then(() => this.checkIfNutraBannerNeedToRender());
      }
    });
  }

  async ngOnInit(): Promise<void> {
    this.scrollDepth.init(ScrollDepthPageName.HOME);
    this.appBridge.setStatusBarColor('cure/light');
    this.startTimer = new Date().getTime();
    this.user = this.conn.getActingUser();
    this.userLanguage = this.user.get('languagePreference');
    this.gridDisplayLanguage = this.languageService.getDisplayLanguage(this.user?.get('languagePreference'));
    this.bentoGridCards = HomepageInfoCardsData[this.gridDisplayLanguage];
    this.userAge = this.user?.get('Age');
    this.userName = this.user?.get('PatientName');
    this.userFirstName = this.userName?.split(' ')[0];
    this.localStorageService.delete('fromSelfCheckupBanner')
    // Reaching home ends any onboarding flow: clear the flag so a later main-concern visit
    // (e.g. adding a concern) backs out to home rather than the class-selection page.
    this.localStorageService.delete('onboardingFlow');
    this.elementPositionService.clearBanners();
    this.isUnpaidUser = this.user.get('orderState') !== ApiClientConstant.User.OrderState.DELIVERED;
    this.skipExecutionForUnpaidUser = this.shouldSkipForUnpaidUser();

    // Subscribing to Redux store for cart updates
    this.subscriptions.push(
      this.store.select(fromSelectors.selectCartProducts).subscribe((products: { [key: string]: number }) => {
        this.cartProductQuantities = { ...products };
        this.toolbarIcons[1].cartValue = Object.values(products).reduce((total: number, quantity: number) => {
          return total + (Number(quantity) || 0);
        }, 0);
      }),
      this.broadcast.on('REFRESH_SHOP_CART').subscribe(() => {
        this.getCart();
      })
    );

    try {
      if (!this.user?.get('allocatedDoctor')) this.conn.getActingUser().fetch();
    } catch (error: any) {
      if (error.code === 209 || error.code === 206) {
        this.eventLogger.trackEvent('iosWhiteScreenIssueHomeInit');
        await this.router.navigate(['/logout'], { replaceUrl: true });
      }
    }
    await this.fetchRegimens();
    await this.loadOrders();
    if (!this.skipExecutionForUnpaidUser) {
      await this.getCart();
    }

    this.regimens = this.regimenService.setRegimenPreparationState(
      this.regimens,
      (updated: any[]): void => {
        this.regimens = updated;
        this.updateLlmChatBotState();
      },
    );
    this.regimenService.updateRegimenPreparationState(this.regimens);
    await this.fetchUserActiveExperiments();
    this.setExploreSectionVisibility();
    await this.experimentService.fetchActiveUserExperiment();
    await this.loadRecommendedProducts();
    if (this.isNewHelpUiExp) {
      await this.getPendingResponseMap();
    }
    const initialOrders = await this.getInitialOrderDetails();
    this.evaluatePaymentDropOffBanner(initialOrders);
    this.gridDisplayLanguage = this.languageService.getDisplayLanguage(
      this.user?.get('languagePreference') ?? ApiClientConstant.LanguageString.EN
    );
    this.bentoGridCards = HomepageInfoCardsData[this.gridDisplayLanguage];
    this.validateAndUpdateBentoGridCards();
    await this.validateAndRenderWeeklyJourneyCard();

    if (this.newRegimenPricingExperiment) {
      this.isRegimenExtraProductBannerVisible = this.regimens
        ?.some((regimen: any): boolean => !regimen.isPreparationTimePending
        && !regimen.active && !regimen.orderPlaced && regimen.class !== this.appConfig.Shared.Regimen.Class.BODY);
    }

    await this.fetchAllocatedDoctorForUser();
    this.userDrImage = this.allocatedDoctor?.doctorDisplayImage || this.allocatedDoctor?.DoctorImageThumbnail
      || 'https://cdn.cureskin.com/app/img/dr-charu-main-concern.png';
    this.findUserStatus();
    await this.fetchCashBalance();
    await this.fetchDiscount();
    this.setGenderIcons();
    this.toolbarIcons[1].homePage = true;
    this.toolbarIcons[1].showCartUI = true;
    this.takePhotoBannerPositionBottom = this.user.get('InstantCheckupTaken') || false;
    await this.loadIncompleteChatBannerData();
    await this.loadIncompleteChatBannerPhotos();
    await this.loadLanguageBannerContent();
    await this.loadCompleteYourProfileSection();
    await this.handleUserPaidStatus();
    this.regimenKit = this.user?.get('PrivateMainConcernClass') || 'FACE';
    await this.fetchInstantCheckups();
    await this.renderTheTakePhotoBanner();
    await this.loadSubmitDefaultAnswersBanner();
    this.setAcqShopBannerVisibility();
    try {
      this.doctorDetails = this.getDoctorDetailsForCheckup();
      await this.checkFollowUpReportAvailable();
      await this.fetchRecentlyViewedProducts();
      await this.fetchDataInParallel();
    } catch (error) {
      this.eventLogger.logError(error);
    }
    try { this.investigationStatus = await this.conn.getInvestigationStatus(); } catch { /* non-critical */ }
    this.loading = false;
    const { showBanner }: { showBanner: boolean } = this.crossSellRegimenService.evaluateCrossSellProps(this.regimens, this.crossSellRegimenExperiment);
    this.showNewCrossRegimenBanner = showBanner;
    this.appWebBridgeService.clearHistory();
    this.defaultDoctorImage = 'https://cdn.cureskin.com/doctor/thumbnail/Dr.charu.jpg';
    this.checkForPolicyUpdate();
    this.newRegimenBannerRenderLogic();
    this.bottomSheetTimer = setTimeout((): void => { this.openBottomSheet(); }, 1000);
    const time = new Date().getTime() - this.startTimer;
    this.isiOSDevice = (await this.appWebBridgeService.requestOSInformation()) === 'iOS' || this.window.isSafariBrowser();
    await this.checkIfNotificationBannerNeedsToBeDisplayed();
    this.showRegimenReorderBanner = await this.regimenReorderService.shouldShowReorderBanner();
    this.regimenReorderKitDetails = this.regimenReorderService.getRegimenReorderKitDetials();
    await this.shouldShowRegimenExpiryBanner();
    await this.getNutraPushData();
    this.showRegimenExpiredBanner = this.regimenExpiryService.shouldShowRegimenExpiredBanner({
      regimens: this.regimens,
      totalAmountSpent: this.user.get('totalAmountSpent'),
      isPaidUser: this.userStatus.PAID,
      consultationSession: this.consultationSession,
    });
    this.regimenExpiredBannerData = {
      firstName: this.userFirstName,
      image: this.allocatedDoctor?.doctorDisplayImage || this.allocatedDoctor?.DoctorImageThumbnail || 'https://storage.googleapis.com/heallo-other-user-files/doctor_api_charu_07302024_1722317224002.jpg',
    }
    if (this.gamificationExperiment && this.user?.get('orderState') === this.appConfig.Shared.User.OrderState.DELIVERED) {
      this.userRewards = await this.conn.fetchRewards({user: this.user});
      await this.checkForGamificationBanner();
    }
    this.subscriptions.push(
      this.broadcast.on<string>('ACTIVITY_RESUME').subscribe((authInfo: string) => {
        this.zone.run(() => {
          (async () => {
            await this.checkIfNotificationBannerNeedsToBeDisplayed();
          })().catch(err => {
            console.error('Error in ACTIVITY_RESUME handler:', err);
          });
        });
      })
    );
    this.eventLogger.trackEvent('home_page_loading_time', { userId: this.user.id, timeInMilliSec: time, userOrderState: this.user?.get('orderState') });
    this.changeDetectorRef.detectChanges();
    this.scrollDepth.pageReady();
  }

  async checkForGamificationBanner(): Promise<void> {
    if (!this.gamificationExperiment?.variant) {
      this.resetGamificationBanners();
      return;
    }

    const regimenId = this.latestActiveRegimen?.objectId;
    this.todayProductUsageData = await this.conn.getProductUsage(regimenId);

    if (this.isUserGamificationExpired() || this.isUserGamificationCompleted()) {
      this.resetGamificationBanners();
      return;
    }

    const streakThresholdExceeded = this.todayProductUsageData.streak >= 7;
    const reward = await this.getRewardIfExists();
    const rewardClaimed = this.isRewardClaimed();

    this.updateRewardBannerVisibility(reward, streakThresholdExceeded);
    this.updateGamificationBannerVisibility(streakThresholdExceeded, rewardClaimed);
  }

  private isUserGamificationCompleted(): boolean {
    const hasReward = this.hasScratchCardReward();
    const rewardAssignedOnDay7 = this.todayProductUsageData?.bannerDay === 7;
    const currentStreak = this.todayProductUsageData?.streak || 0;
    const isPastDay7 = currentStreak !== 7;

    return hasReward && rewardAssignedOnDay7 && isPastDay7;
  }

  private isUserGamificationExpired(): boolean {
    return this.todayProductUsageData.daysSinceDelivery >= 14 &&
      this.todayProductUsageData.bannerDay === 1 &&
      this.todayProductUsageData.streak === 0
  }

  private resetGamificationBanners(): void {
    this.shouldShowGamification = false;
    this.shouldShowGamificationRewardBanner = false;
    this.rewardData = null;
  }

  private hasScratchCardReward(): boolean {
    return !!(
      this.todayProductUsageData?.scratchCardReward?.objectId
    );
  }

  isRewardClaimed(): boolean {
    if (!this.hasScratchCardReward()) {
      return false;
    }

    const reward = this.findRewardById(this.todayProductUsageData.scratchCardReward.objectId);
    if (!reward) {
      return false;
    }

    return reward?.get?.('isClaimed') || reward?.isClaimed || false;
  }

  private async getUnclaimedRewardIfExists(): Promise<{ objectId: string; amount?: number; expireAt?: { iso?: string } } | null> {
    if (!this.hasScratchCardReward()) {
      return null;
    }

    const reward = this.findRewardById(this.todayProductUsageData.scratchCardReward.objectId);
    if (!reward) {
      return null;
    }

    const isClaimed = reward?.get?.('isClaimed') || reward?.isClaimed;
    if (isClaimed) {
      return null;
    }

    return this.buildRewardData(reward);
  }

  private async getRewardIfExists(): Promise<{ objectId: string; amount?: number; expireAt?: { iso?: string } } | null> {
    if (!this.hasScratchCardReward()) {
      return null;
    }

    const reward = this.findRewardById(this.todayProductUsageData.scratchCardReward.objectId);
    if (!reward) {
      return null;
    }

    return this.buildRewardData(reward);
  }

  private findRewardById(rewardObjectId: string): any {
    return this.userRewards?.find((singleReward: any) => {
      const rewardId = singleReward.objectId || singleReward.get?.('objectId') || singleReward.id;
      return rewardId === rewardObjectId;
    });
  }

  private buildRewardData(reward: any): { objectId: string; amount?: number; expireAt?: { iso?: string } } {
    const cashTransaction = reward.get?.('cashTransaction') || reward.cashTransaction;
    const amount = cashTransaction?.amount || cashTransaction?.get?.('amount') || reward.get?.('amount') || reward.amount;
    const expireAt = reward.get?.('expireAt') || reward.expireAt;
    const rewardId = reward.objectId || reward.get?.('objectId') || reward.id;

    return {
      objectId: rewardId,
      amount: amount,
      expireAt: expireAt
    };
  }

  private updateRewardBannerVisibility(
    reward: { objectId: string; amount?: number; expireAt?: { iso?: string } } | null,
    streakThresholdExceeded: boolean,
  ): void {
    const isDay7 = this.todayProductUsageData?.streak === 7;

    if (reward && streakThresholdExceeded && isDay7) {
      if (!this.showScratchCard) {
        this.rewardData = reward;
      }
      this.shouldShowGamificationRewardBanner = true;
    } else {
      if (!this.showScratchCard) {
        this.rewardData = null;
      }
      this.shouldShowGamificationRewardBanner = false;
    }
  }

  private updateGamificationBannerVisibility(streakThresholdExceeded: boolean, rewardClaimed: boolean): void {
    if (rewardClaimed) {
      const isDay7 = this.todayProductUsageData?.streak === 7 &&
        this.todayProductUsageData?.bannerDay === 7;
      if (!isDay7) {
        this.shouldShowGamification = false;
      }
      return;
    }

    if (streakThresholdExceeded) {
      this.shouldShowGamification = false;
    } else {
      this.shouldShowGamification = !this.shouldShowGamificationRewardBanner;
    }
  }

  getGamificationBannerPosition(): string | null {
    if (!this.todayProductUsageData?.daysSinceDelivery) {
      return null;
    }

    const days = this.todayProductUsageData.daysSinceDelivery;

    if (days >= 1 && days <= 2) {
      return UserHomeComponent.GAMIFICATION_BANNER_POSITION_2_DAYS;
    } else if (days >= 3 && days <= 4) {
      return UserHomeComponent.GAMIFICATION_BANNER_POSITION_4_DAYS;
    } else if (days >= 5) {
      return UserHomeComponent.GAMIFICATION_BANNER_POSITION_5_DAYS_PLUS;
    }

    return null;
  }

  shouldShowMainGamificationBannerAtPosition(position: string): boolean {
    const currentPosition = this.getGamificationBannerPosition();
    return currentPosition === position &&
           this.shouldShowGamification &&
           this.todayProductUsageData &&
           !this.shouldShowGamificationRewardBanner;
  }

  async onScratchCardDismissedWithoutClaim(): Promise<void> {
    this.userRewards = await this.conn.fetchRewards({ user: this.user });
    await this.checkForGamificationBanner();
    this.changeDetectorRef.detectChanges();
  }

  onOpenScratchCard(): void {
    if (this.rewardData) {
      this.showScratchCard = true;
    }
  }

  onScratchCardClosed(): void {
    this.showScratchCard = false;
    this.checkForGamificationBanner();
  }

  async onRewardClaimed(reward: any): Promise<void> {
    resetCacheByName('fetchCashBalance');
    await this.fetchCashBalance();

    if (reward?.refreshBanner) {
      await this.checkForGamificationBanner();
    }
    this.changeDetectorRef.detectChanges();
  }

  async validateAndRenderWeeklyJourneyCard(): Promise<void> {
    if (this.experimentService.isRetentionHomeRevampExperimentEnabled) {
      return;
    }
    if (this.isWeeklyJourneyExperiment || this.weeklyJourneyV2Experiment) {
      await this.showWeeklyJourneyCard();
    }
  }

  getDoctorDetailsForCheckup(): { firstName: string; image: string, specialization: string } {
    if (this.allocatedDoctor) {
      const doctorName = this.allocatedDoctor.DoctorDisplayName || this.allocatedDoctor.username;
      return {
        firstName: doctorName.split(' ').slice(0, 2).join(' ') || '',
        image: this.allocatedDoctor.doctorDisplayImage,
        specialization: 'Skin Specialist'
      };
    }
    return {
      firstName: 'Dr. Charu',
      image: 'https://storage.googleapis.com/heallo-other-user-files/doctor_api_charu_07302024_1722317224002.jpg',
      specialization: 'Dermatologist'
    };
  }

  handleCheckupBannerClick(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'level-two-checkup-due-banner' }));
    this.startFollowUp('ANYTIME_FOLLOWUP_BANNER');
  }

  ngAfterViewInit(): void {
    const subscription = this.elementPositionService
      .initializeTracking(this.trackableDirectives)
      .subscribe();

    this.subscriptions.push(subscription);
  }

  private updateDiscomfortBannerVisibility(): void {
    const BANNER_KEY = 'discomfortBannerFirstSeen';
    const threeDaysMs = 3 * 24 * 60 * 60 * 1000;

    const seenTime = localStorage.getItem(BANNER_KEY);

    if (!seenTime) {
      localStorage.setItem(BANNER_KEY, this.startTimer.toString());
      this.showDiscomfortBanner = true;
    } else {
      const seenTimeNum = Number(seenTime);
      const hasExpired = this.startTimer - seenTimeNum > threeDaysMs;

      this.showDiscomfortBanner = !hasExpired;
    }
  }

  determineSelfCheckupFlow(): void {
    this.resetSelfCheckupWindowState();

    const context = this.getSelfCheckupWindowContext();
    if (!context) return;

    const result = this.selfCheckupService.computeSelfCheckupWindow(context);
    this.isWithinSelfCheckupWindow = result.isWithinSelfCheckupWindow;
  }

  private resetSelfCheckupWindowState(): void {
    this.selfCheckupWindowDetermined = true;
    this.isWithinSelfCheckupWindow = false;
    this.selfCheckupDaysSinceLastDelivery = null;
  }

  private getSelfCheckupWindowContext(): SelfCheckupWindowContext | null {
    const variant = this.selfCheckupPhotoExperiment.variant;
    const variantClasses: string[] = variant.class;
    const latestOrder = this.orderService.getLatestDeliveredRegimenOrder(this.allActiveOrders ?? []);

    if (!latestOrder) return null;

    const regimenClass = latestOrder?.get('regimen')?.get('class');
    if (!regimenClass || !variantClasses.includes(regimenClass)) {
      return null;
    }

    this.selfCheckupDaysSinceLastDelivery = this.orderService.getDaysSinceDelivered(latestOrder);
    return {
      variant: {
        start_day: variant.start_day,
        end_day: variant.end_day,
        class: variantClasses,
      },
      deliveredOn: this.orderService.getDeliveredOn(latestOrder),
    };
  }

  async fetchInstantCheckups():Promise<void> {
    const type = [this.appConfig.Shared.InstantCheckup.Type.FRONT_FACE];
    this.instantCheckups = await this.conn.fetchInstantCheckup({ userId: this.user.get('username'), type, limit: 5, sortAscending: true });
  }

  async renderTheTakePhotoBanner(): Promise<void> {
    if (this.userStatus.PAID) {
      this.isTakePhotoBannerEligible = false;
      return;
    }

    const frontFaceInstantCheckups = this.instantCheckupHelper.getCheckupsByType(this.instantCheckups,
      this.appConfig.Shared.InstantCheckup.Type.FRONT_FACE);

    this.isTakePhotoBannerEligible = this.takePhotoBannerService.shouldRenderBanner(frontFaceInstantCheckups,
      this.regimens,
      this.allActiveOrders);

    if (this.isTakePhotoBannerEligible) {
      this.takePhotoBannerTrigerringStates = this.takePhotoBannerService.getBannerTriggeringStates();
      this.activeTakePhotoBannerState = Object.entries(this.takePhotoBannerTrigerringStates).find(
        ([key, value]: [string, boolean]):any => value === true)?.[0];
      this.eventLogger.cleverTapEvent('upload_photo_banner_displayed', JSON.stringify({ banner_type: this.activeTakePhotoBannerState }));
    } else {
      this.eventLogger.cleverTapEvent('upload_photo_banner_not_displayed', '{}', [
        this.appConfig.Shared.EventTracker.CLEVER_TAP,
        this.appConfig.Shared.EventTracker.MOENGAGE,
        this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
      ]);
    }
  }

  async loadSubmitDefaultAnswersBanner(): Promise<void> {
    const bannerItems = await this.consultationSessionService.getSubmitDefualtAnswersBannerItems(this.user, this.instantCheckups);
    this.submitDefualtAnswersBannerItems = bannerItems.filter(item => item.thumbnailUrl);
  }

  async handleTakePhotoBannerClick(): Promise<void> {
    this.eventLogger.cleverTapEvent('upload_photo_banner_clicked', JSON.stringify({
      banner_type: this.activeTakePhotoBannerState,
    }));

    const redirectUrl = this.router.url;
    this.localStorageService.setValue('CureSkin/redirectUrl', redirectUrl);
    const tag = this.appConfig.Shared.InstantCheckup.Type.FRONT_FACE;
    this.router.navigate(['user/instantCheckup/preview'], { queryParams: { tag, fromTakePhotoBanner: 'true' } });
  }

  onAfterInitOfMainSwiper(): void {
    setTimeout((): void => {
      this.isMainSwiperMounted = true;
    }, 3000);
  }

  async fetchAllocatedDoctorForUser(): Promise<void> {
    if (this.user.get('allocatedDoctor')?.id) {
      this.allocatedDoctor = await this.userAllocatedDoctorService.getAllocatedDoctor();
    }
  }

  async fetchCashBalance(): Promise<void> {
    this.minimumCash = this.appConfig.Shared.experimentVariants.SHOP_PAGE_CASH_VISIBILITY.minCash;
    this.totalCashBalance = await this.conn.fetchCashBalance();
    if (this.totalCashBalance >= this.minimumCash && this.userStatus.PAID) {
      this.showCashBalance = true;
    }
  }

  checkForPolicyUpdate(): void {
    if (this.user) {
      const userPrivacyLogDates = this.user?.get('termsOfServiceAcceptedDates');
      if (userPrivacyLogDates && userPrivacyLogDates.length) {
        const lastLog = [...userPrivacyLogDates].pop();
        const date1 = lastLog;
        const date2 = new Date();
        const daysDifference = this.timeService.getDaysDifference(date1, date2);
        if (daysDifference >= 365) this.openPrivacyPolicySheet();
      } else this.openPrivacyPolicySheet();
    }
  }

  async openPrivacyPolicySheet(): Promise<void> {
    if (this.conn.isInternalUser()) return;
    this.showUpdatedPrivacyPopup = true;
    setTimeout((): void => {
      this.bottomSheet.open(PrivacyPolicySheetComponent, {
        data: {
          callback: async (): Promise<void> => {
            await this.conn.logPrivacyPolicyDate();
          },
        },
        disableClose: true,
      });
    }, 1000);
  }

  // eslint-disable-next-line complexity
  async checkForReAcquisitionBannerAndResponse(): Promise<void> {
    if (this.skipExecutionForUnpaidUser || this.regimens?.length) return;

    // if user total amount spent is lesser than minimumSpentAmount of experiment then we should not show re-acq banner
    if ((this.user?.get('totalAmountSpent') || 0) < this.minimumAmountSpentFromReAcq) {
      return;
    }
    this.regimenExpiryService.setReAcquisitionBannerShown(false);
    const callPending = await this.conn.getCountOfUserPendingCall({
      where: {
        user: this.user,
        type: ApiClientConstant.PendingCall.Type.ReacquisitionCall,
        status: this.appConfig.Shared.PendingCall.Status.CallCompleted,
        createdAt: { $gte: this.timeService.removeMonths(new Date(), 4) },
      },
    });
    let reAcquisitionResponse = this.user?.get('reAcquisitionResponse');
    if (!reAcquisitionResponse) {
      const res = { totalReAcquisitionResponse: 0, reAcquisitionResponseYes: false };
      reAcquisitionResponse = res;
    }
    if (reAcquisitionResponse.lastReAcquisititionResponseTime
      && (this.timeService.differenceInDays(new Date(), new Date(reAcquisitionResponse.lastReAcquisititionResponseTime)) >= 120)) {
      reAcquisitionResponse.totalReAcquisitionResponse = 0;
      reAcquisitionResponse.reAcquisitionResponseYes = false;
      delete reAcquisitionResponse.lastReAcquisititionResponseTime;
      this.user.set('reAcquisitionResponse', reAcquisitionResponse);
      await this.user.save();
    }
    if (!reAcquisitionResponse?.totalReAcquisitionResponse) reAcquisitionResponse.totalReAcquisitionResponse = 0;
    if (this.user?.get('marketingTags')?.includes(this.appConfig.Shared.MarketingTags.Type.ON_REGIMEN)
      || this.user?.get('orderState') !== this.appConfig.Shared.User.OrderState.DELIVERED
      || callPending) {
      return;
    }
    if (reAcquisitionResponse?.totalReAcquisitionResponse < 2 && !reAcquisitionResponse.reAcquisitionResponseYes) {
      let showFollowUpBanner$;
      this.store.select(fromSelectors.selectHomePageState).subscribe((data: any): void => {
        showFollowUpBanner$ = data.showFollowUpBanner;
      });
      this.showFollowupPopup = showFollowUpBanner$;
      if (this.showFollowupPopup) {
        this.bottomSheetPriority.push('FollowUpChatSheetComponent');
      }
    }
    await this.decideReAcquisitionBannerType();
  }

  async decideReAcquisitionBannerType(): Promise<void> {
    const bannerType = await this.reAcquisitionService.decideReAcquisitionBannerType(this.user);
    if (bannerType) {
      this.reAcquisitionBannerType = bannerType;
      this.regimenExpiryService.setReAcquisitionBannerShown(true);
    }
  }

  async openReAcquisitionPage(): Promise<void> {
    if (this.reAcquisitionBannerType === 'reAcquisitionBannerReady') {
      const oldReAcquisitionResponse = this.user?.get('reAcquisitionResponse') || { totalReAcquisitionResponse: 0 };
      const updatedReAcquisitionResponse = {
        totalReAcquisitionResponse: oldReAcquisitionResponse.totalReAcquisitionResponse += 1,
        reAcquisitionResponseYes: true,
        lastReAcquisititionResponseTime: new Date().toISOString(),
      };
      this.user.set('reAcquisitionResponse', updatedReAcquisitionResponse);
      await this.user.save();
    }
    if (this.reAcquisitionBannerType === 'missedReAcquisitionCall') {
      this.router.navigate(['/support']);
      return;
    }

    this.router.navigate(['/re-acquisition/concern-selection']);
  }

  setGenderIcons(): void {
    const gender = this.user?.get('Gender');
    if (gender === this.appConfig.Shared.Gender.MALE) {
      this.faceIconUrl = 'https://cdn.cureskin.com/app/img/rebranded-male-face.svg';
      this.hairIconUrl = 'https://cdn.cureskin.com/app/img/rebranded-male-hair.svg';
      this.bodyIconUrl = 'https://cdn.cureskin.com/app/img/Male%20Body_1.png';
    } else if (gender === this.appConfig.Shared.Gender.FEMALE) {
      this.faceIconUrl = 'https://cdn.cureskin.com/app/img/rebranded-female-face.svg';
      this.hairIconUrl = 'https://cdn.cureskin.com/app/img/rebranded-female-hair.svg';
    }
  }

  private async handleGameNewExperiment(): Promise<void> {
    if (this.skipExecutionForUnpaidUser) return;
    this.showGameBanner = true;
  }

  private setExploreSectionVisibility(): void {
    this.exploreService.handleExploreTabExperiment(this.experiments, this.user?.get('orderState'));
  }

  // app-explore-contact-banners shows content only for the "Connect with us"
  // (unpaid) section; otherwise skip its wrapper so it leaves no empty margin.
  get shouldShowExploreContactBanner(): boolean {
    return !this.userStatus.PAID;
  }

  async fetchUserActiveExperiments(): Promise<void> {
    this.experiments = await this.conn.findUserActiveExperiments();
    this.isAOVActive = await this.personalisedPromotionsService.isAOVActiveInPersonalisedPromotions(this.user);
    // eslint-disable-next-line complexity
    this.experiments?.forEach(async (experiment: any): Promise<void> => {
      switch (experiment.key) {
        case 'show_diet_banner':
          this.showDietBanner = true;
          break;
        case '2499_upsell':
          this.is2499Upsell = true;
          break;
        case 'game_new':
          await this.handleGameNewExperiment();
          break;
        case 'game_quiz_multiple_questions':
          this.isMultipleQuestionQuiz = true;
          break;
        case 'buy1_get1_sale': {
          await this.processBuy1Get1SaleExperiment(experiment);
          break;
        }
        case 'aov_gamification':
          if (!this.isAOVActive) break;
          this.aovBannerImage = experiment.variant.bannerImagesMultiple[this.user?.get('languagePreference')]
            || experiment.variant.bannerImagesMultiple?.en;
          if (this.aovBannerImage) this.isAovSaleLive = true;
          break;
        case 'sale_offers_retention':
          this.bannerImage = experiment.variant.bannerImage;
          this.isSaleLive = true;
          break;
        case 'doctor_order_banner':
          this.drOrderBannerHome = true;
          break;
        case 'boost_your_regimen':
          this.isBoostYourRegimenExperiment = true;
          break;
        case 'festival_delay_banner_enabled':
          this.festivalDelayBannerEnabled = true;
          break;
        case 'weekly_journey':
          this.isWeeklyJourneyExperiment = true;
          break;
        case 'rebranding_home_top_icon':
          this.isRebrandingHomeIcon = true;
          break;
        case 'hair_thinning_cross_sell_banner':
          this.isHairThinningCrossSellBanner = true;
          break;
        case 'hair_fall_cross_sell_banner':
          this.isHairFallCrossSellBanner = true;
          break;
        case 'hair_fall_cross_sell_male_banner':
          this.isHairFallCrossSellMaleBanner = true;
          break;
        case 'voice_note_by_script':
          this.fetchCartProductAddedByScript();
          break;
        case 'self_checkup_with_photo':
          this.selfCheckupPhotoExperiment = experiment;
          break;
        case 'add_extra_regimen_products':
          this.newRegimenPricingExperiment = experiment;
          break;
        case 'new_help_ui':
          this.isNewHelpUiExp = true;
          break;
        case 'nutra_repeat_banner_HP':
          await this.handleNutraBannerExperiment(experiment);
          break;
        case 'voice_note_banner_day_14':
          this.disableTwoWeekExpectationVoiceNoteExp = true;
          break;
        case 'unpaid_user_llm_bot':
          this.unpaidUserChatBotVariant = experiment.variant;
          this.checkForLlmChatBot(experiment.variant);
          break;
        case 'nutra_push':
          this.handleNutraPushExperiment(experiment);
          break;
        case 'buy_now_flow':
          this.buyNowFlowExperiment = true;
          break;
        case 'regimen_expiry_banner':
          this.regimenExpiryExperiment = experiment;
          break;
        case 'weekly_journey_v2':
          this.weeklyJourneyV2Experiment = true;
          this.weeklyJourneyVariant = experiment?.variant;
          break;
        case 'cart_script_banner_header':
          this.cartScriptBannerHeaderExperiment = true;
          break;
        case 'gamification':
          this.gamificationExperiment = experiment;
          break;
        case 'checkup_bs_homepage':
          this.isCheckupBsHomepageExperimentEnabled = true;
          this.checkupBsHomepageVariant = experiment.variant || {};
          break;
        case 'acq_payment_dropOff':
          this.acqPaymentDropOffExperiment = true;
          break;
        case 'cross_sell_regimen_v2':
          this.crossSellRegimenExperiment = experiment;
          break;
        default:
          break;
      }
    });
  }

  async processBuy1Get1SaleExperiment(experiment: any): Promise<void> {
    if (this.skipExecutionForUnpaidUser) return;
    this.saleBannerImage = experiment.variant.bannerImage;
    const saleProds = await this.conn.findBogoSaleProds();
    if (saleProds?.length) {
      this.isBOGOSaleLive = true;
    }
  }

  checkForLlmChatBot(variant: any): void {
    if (!variant) return;
    if (!this.latestUnBoughtRegimen ||
      Object.keys(this.latestUnBoughtRegimen).length === 0
    ) return;

    const isLanguageSupported: boolean = variant.languages.includes(this.userLanguage);
    const showInRegimenPage: boolean = variant.pagesToShow.includes(this.appConfig.Shared.TABS.HOME);
    this.unpaidUserChatBotExperiment = isLanguageSupported
      && showInRegimenPage
      && !this.regimenService.isAnyRegimenPreparationOngoing()
      && this.userService.hasNotPlacedOrder(this.user);
  }

  updateLlmChatBotState(): void {
    if (!this.unpaidUserChatBotVariant) return;

    this.checkForLlmChatBot(this.unpaidUserChatBotVariant);

    this.changeDetectorRef.detectChanges();
  }

  async handleNutraBannerExperiment(experiment: any): Promise<void> {
    if (this.user.get('orderState') !== ApiClientConstant.User.OrderState.DELIVERED) return;
    this.nutraBannerExperiment = true;
    this.nutraBannerExperimentVariantData = experiment;
    this.nutraProductsInfo = this.nutraBannerExperimentVariantData?.variant?.nutraProductsData;
    await this.getActiveAndCompletedOrders().then(() => this.checkIfNutraBannerNeedToRender());
  }

  private async handleUserPaidStatus(): Promise<void> {
    if (this.user.isPaid()) {
      this.showDietBanner = true;
      this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'home-open-paid' }));
    } else {
      this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'home-open-unpaid' }));
    }
  }

  private async fetchDataInParallel(): Promise<void> {
    await Promise.all([
      this.checkForReAcquisitionBannerAndResponse(),
      this.loadLatestDeliveredOrder(),
      this.fetchBlog(),
      this.fetchUserFollowUp(),
      this.fetchOtherDataBasedOnUserState(),
      this.fetchSupportTickets(),
      this.fetchPendingDiscomfortSupportTicket(),
      this.fetchResolvedDiscomfortSupportTicket(),
      this.fetchFeedback(),
      this.fetchOrderChat(),
    ]);
  }

  openBottomSheetForCash(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'home-cash-banner-click' }));
    this.bottomSheet.open(CureskinCashSheetComponent, {
      data: { data: this.totalCashBalance, url: '/user?tab=shop&back=home' },
    });
  }

  async getPendingResponseMap(): Promise<void> {
    if (this.skipExecutionForUnpaidUser) return;
    const pendingResponseMap = await this.conn.findAllPendingTicketWithAwaitingResponse();
    this.isTicketAwaitingResponse = Object.values(pendingResponseMap).some(value => value === true);
  }

  async openBottomSheet(): Promise<void> {
    if (this.conn.isInternalUser() || this.showUpdatedPrivacyPopup || this.showNotificationEnablePopUp) return;
    // Get the last opened date
    const lastOpenedDate = this.localStorage.getValue('anytimeFollowupLastOpenedDate');
    const currentDate = new Date().toISOString().split('T')[0]; // Get current date in YYYY-MM-DD format
    if (this.bottomSheetPriority.includes('AnytimeFollowupComponent')
      && lastOpenedDate !== currentDate) {
      let opened = false;
      if (this.isCheckupBsHomepageExperimentEnabled) {
        opened = await this.openActiveCheckupBottomSheet();
      }
      if (!opened) {
        this.bottomSheet.open(AnytimeFollowupComponent, {
          data: {
            doctorProfileImageURL: this.followUpDoctor?.doctorDisplayImage
              ?? 'https://storage.googleapis.com/heallo-other-user-files/doctor_api_charu_07302024_1722317224002.jpg',
            reportType: this.resolveFollowUpReportType(),
            callback: (): void => {
              this.startFollowUp('ANYTIME_FOLLOWUP_POPUP_CLICKED');
            },
          },
        });
      }
      // Update `LocalStorageService` with the current date
      this.localStorage.setValue('anytimeFollowupLastOpenedDate', currentDate);
      return;
    }
    if (this.bottomSheetPriority.includes('FollowUpChatSheetComponent')) {
      this.bottomSheet.open(FollowUpChatSheetComponent, {
        data: { user: this.user },
      });
      return;
    }
    this.tryOpenIncompleteChatSheet();
  }

  private tryOpenIncompleteChatSheet(): void {
    if (this.destroyed || this.isMenuOpen) return;
    if (this.conn.isInternalUser() || this.showUpdatedPrivacyPopup || this.showNotificationEnablePopUp) return;
    if (!this.bottomSheetPriority.includes('IncompleteChatSheetComponent')) return;
    if (this.incompleteChatBannerService.isBottomSheetShown()) return;
    this.incompleteChatBannerService.setBottomSheetShown(true);
    this.bottomSheet.open(IncompleteChatSheetComponent, {
      data: {
        regimenClass: this.consultationSession?.get('PrivateMainConcernClass'),
        callback: (): void => {
          this.openConsultation('bottom_sheet');
        },
      },
    });
  }

  private async loadOrders(): Promise<void> {
    const where: any = { user: this.user };
    const select: Array<ParseKeys<Table.Order>> = ['orderNumber', 'type', 'stage', 'deliveredOn', 'actualCreatedAt', 'products', 'productApprovalDetails', 'regimenId'];
    where.stage = [
      ...this.appConfig.Shared.Order.Stage.orderPackedStages,
      ...this.appConfig.Shared.Order.Stage.orderPlacedStages,
      ...this.appConfig.Shared.Order.Stage.orderDispatchedStages,
      ...this.appConfig.Shared.Order.Stage.orderOutForDeliveryStages,
      this.appConfig.Shared.Order.Stage.DELIVERED];

    try {
      let orders: any;
      if (!this.userStatus.PAID) {
        orders = await this.conn.fetchOrders(where, []);
      } else {
        orders = await this.conn.fetchOrders(where, select);
      }
      const orderStages = await this.conn.fetchOrderStages();
      if (orders) {
        orders.forEach((order: any): void => {
          order.set('orderStage', orderStages.find((orderStage: any): boolean => orderStage.name === order?.get('stage')) || {});
        });
      }
      this.allActiveOrders = orders;
      this.userActiveOrders.update((prevOrders) => [...prevOrders, ...(orders || [])]);
      this.allActiveOrders.filter((order: Table.Order) => order.get('type') === ApiClientConstant.Order.Type.REGIMEN && order.get('stage') === ApiClientConstant.Order.Stage.DELIVERED);

      this.isotretinoinConsentPendingOrder = (this.allActiveOrders || []).find(
        (order: any): boolean => order?.get('stage') === this.appConfig.Shared.Order.Stage.ISOTRETINOIN_CONSENT_PENDING,
      ) || null;

      if (this.isotretinoinConsentPendingOrder) {
        this.conn.getUserExtraInformation().then((info: any): void => {
          this.isotretinoinPregnancyAnswered = !!info?.isotretinoinPregnancyStatusUpdated;
        }).catch((): void => {});
      }

      if (this.allActiveOrders) {
        this.allActiveOrders.forEach((order: any): any => {
          if (order?.get('stage') === this.appConfig.Shared.Order.Stage.DELIVERED) {
            const deliveredDate = new Date(order?.get('deliveredOn'));
            const differenceBetweenCurrentDateAndDeliveryDate = this.timeService.differenceInDays(new Date(), deliveredDate);
            if (differenceBetweenCurrentDateAndDeliveryDate < 2) {
              order.set('showOrderDeliveredBanner', true);
              if (this.experimentService.isRetentionHomeRevampExperimentEnabled
                && order.get('type') === ApiClientConstant.Order.Type.REGIMEN) {
                this.hasRecentlyDeliveredRegimen = true;
              }
            }
          }
        });
      }
    } catch (error) {
      this.eventLogger.logError(error);
      this.broadcast.broadcast('NOTIFY', { message: error.toString() });
    }
  }

  showOrderDeliveryVideosBanner(order: Table.Order): boolean {
    if (!this.experimentService.isRetentionHomeRevampExperimentEnabled) return false;
    if (order?.get('type') !== ApiClientConstant.Order.Type.REGIMEN) return false;
    if (order?.get('stage') !== this.appConfig.Shared.Order.Stage.DELIVERED) return false;
    const daysSinceDelivery = this.timeService.differenceInDays(new Date(), new Date(order.get('deliveredOn')));
    return daysSinceDelivery >= this.orderDeliveryBannerStartDay && daysSinceDelivery <= this.orderDeliveryBannerEndDay;
  }

  get orderDeliveryVideoBannerOrders(): Array<Table.Order> {
    return (this.allActiveOrders || []).filter((order: Table.Order): boolean => this.showOrderDeliveryVideosBanner(order));
  }

  getRegimenForOrder(order: Table.Order): AllocatedRegimen {
    const regimenId = order?.get('regimenId');
    if (!regimenId) return null;
    return (this.regimens || []).find((regimen: AllocatedRegimen): boolean => regimen?.regimenId === regimenId) || null;
  }

  get dietBannerRegimen(): AllocatedRegimen {
    const regimens: Array<AllocatedRegimen> = this.regimens || [];
    const FACE = this.appConfig.Shared.Regimen.Class.FACE;
    const HAIR = this.appConfig.Shared.Regimen.Class.HAIR;
    // Retention-only: surface the banner only for an ACTIVE, delivered regimen (FACE over HAIR).
    // No active regimen → no diet banner on the home page.
    return regimens.find((regimen: AllocatedRegimen): boolean => regimen?.class === FACE && regimen?.active && !!regimen?.deliveredDate)
      || regimens.find((regimen: AllocatedRegimen): boolean => regimen?.class === HAIR && regimen?.active && !!regimen?.deliveredDate)
      || null;
  }

  get isDietBannerCollapsed(): boolean {
    return this.dietBannerService.isCollapsed(this.dietBannerRegimen, DIET_BANNER_PAGE.HOME);
  }

  private get canShowDietBanner(): boolean {
    return !!(this.isRetentionHomeRevampExperimentEnabled && this.dietBannerRegimen && this.isPaidUser);
  }

  get showDietBannerExpanded(): boolean {
    return this.canShowDietBanner && !this.isDietBannerCollapsed;
  }

  get showDietBannerCollapsed(): boolean {
    return this.canShowDietBanner && this.isDietBannerCollapsed;
  }

  newRegimenBannerRenderLogic(): void {
    this.regimens.forEach((regimen: AllocatedRegimen): void => {
      if (!regimen.active) {
        if (regimen.class === this.appConfig.Shared.Regimen.Class.FACE) {
          if (this.hairBannerIndex === -1) this.skinBannerIndex = 0;
          else this.skinBannerIndex = 1;
        } else if (regimen.class === this.appConfig.Shared.Regimen.Class.HAIR) {
          if (this.skinBannerIndex === -1) this.hairBannerIndex = 0;
          else this.hairBannerIndex = 1;
        }
      }
    });
  }

  async loadLatestDeliveredOrder(): Promise<void> {
    this.latestOrder = this.findLatestDeliveredRegimenOrder();
    await this.checkLastDeliveredOrder();
  }

  fetchCartProductAddedByScript(): any {
    let latestProduct = null;
    this.cartItems?.forEach((item: any): any => {
      if (item.isDoctorAdded && item.isAddedByScript && item.scriptAudioUrl) {
        if (!latestProduct || new Date(item.createdAt) > new Date(latestProduct.createdAt)) {
          latestProduct = item;
        }
      }
    });
    this.productAddedByScript = latestProduct;
    if (this.productAddedByScript) this.voiceNoteByScript = true;
  }

  // Copies the doctor voice-note script fields (isAddedByScript / scriptAudioUrl / createdAt)
  // from the legacy cart lineItems onto the new cart API lineItems, matched by productId.
  // The new cart API doesn't expose these fields yet; without this, the voice-note banner
  // and the script-added header variants never render.
  mergeScriptFieldsFromLegacyCart(legacyLineItems: any[]): void {
    if (!this.cartItems?.length || !legacyLineItems?.length) return;
    const legacyByProductId = new Map<string, any>();
    legacyLineItems.forEach((item: any): void => {
      if (item?.productId) legacyByProductId.set(item.productId, item);
    });
    if (!legacyByProductId.size) return;
    this.cartItems.forEach((item: any): void => {
      const legacy = item?.productId ? legacyByProductId.get(item.productId) : undefined;
      if (!legacy?.isAddedByScript) return;
      item.isAddedByScript = legacy.isAddedByScript;
      item.scriptAudioUrl = legacy.scriptAudioUrl;
      item.createdAt = legacy.createdAt;
    });
  }

  async showWeeklyJourneyCard(): Promise<void> {
    this.isJourneyCardOne = false;
    this.isWeekOne = false;
    this.isJourneyCardTwo = false;
    this.isJourneyCardThree = false;
    this.isJourneyCardFour = false;
    this.isWeekThreeJourneyCard = false;
    this.isWeekFourJourneyCard = false;
    this.expectedDeliveryDate = { from: this.timeService.addDays(new Date(), 2),
      to: this.timeService.addDays(new Date(), 2 + this.deliveryIntervalInDays) };
    const concerns = this.user?.get('aiDetections');
    const latestDeliveredOrder = this.findLatestDeliveredRegimenOrder();
    const regimenType = latestDeliveredOrder?.get('regimen')?.get('class');
    if (regimenType === this.appConfig.Shared.Regimen.Class.HAIR) return;
    if (concerns?.length) {
      this.primaryConcern = concerns[0];
      this.otherConcerns = concerns.slice(1).join(', ');
    }
    const sortedOrders = this.orderHelper.sortOrdersByDeliveredOn(this.userActiveOrders(), true);
    this.latestPlacedRegimenOrder = sortedOrders ? sortedOrders.find(order => order.get('type') === this.appConfig.Shared.Order.Type.REGIMEN) : null;

    if (this.faceRegimenOrderPlaced && Object.keys(this.faceRegimenOrderPlaced).length && this.latestPlacedRegimenOrder) {
      this.isJourneyCardOne = true;
      return;
    }
    if (regimenType === this.appConfig.Shared.Regimen.Class.FACE) {
      this.latestFaceRegimenDelivered = latestDeliveredOrder;
    }
    this.pendingCheckInCall = await this.conn.findOnePendingCall({
      where: {
        user: this.user,
        type: this.appConfig.Shared.PendingCall.Type.CHECK_IN,
        status: this.appConfig.Shared.PendingCall.Status.Requested,
        createdAt: { $gte: this.timeService.removeDays(new Date(), 10) },
      },
    });
    const deliveredDate = new Date(this.faceRegimenOrderDelivered?.deliveredDate);
    const differenceBetweenCurrentDateAndDeliveryDate = this.timeService.differenceInDays(new Date(), deliveredDate);
    if (differenceBetweenCurrentDateAndDeliveryDate >= 0 && differenceBetweenCurrentDateAndDeliveryDate < 4) {
      this.isWeekOne = true;
    } else if (differenceBetweenCurrentDateAndDeliveryDate > 3 && differenceBetweenCurrentDateAndDeliveryDate < 7) {
      this.isJourneyCardTwo = true;
    } else if (differenceBetweenCurrentDateAndDeliveryDate > 6 && differenceBetweenCurrentDateAndDeliveryDate < 10) {
      this.isJourneyCardThree = true;
    } else if (differenceBetweenCurrentDateAndDeliveryDate > 9 && differenceBetweenCurrentDateAndDeliveryDate < 14) {
      this.isJourneyCardFour = true;
    } else if (differenceBetweenCurrentDateAndDeliveryDate > 13 && differenceBetweenCurrentDateAndDeliveryDate < 21) {
      this.isWeekThreeJourneyCard = true;
    } else if (differenceBetweenCurrentDateAndDeliveryDate > 20 && differenceBetweenCurrentDateAndDeliveryDate < 28) {
      this.isWeekFourJourneyCard = true;
    }
  }

  trackOrder(url: string): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'track-order-journey-card-1' }), [
      this.appConfig.Shared.EventTracker.CLEVER_TAP,
      this.appConfig.Shared.EventTracker.MOENGAGE,
      this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
    ]);
    if (this.isiOSDevice) this.conn.navigateToURL(url);
    else this.broadcast.broadcast('OPEN_IN_NEW_TAB', { url });
  }

  checkConsultationPopup(): void {
    if (this.conn.isInternalUser()) return;
    this.bottomSheetPriority.push('IncompleteChatSheetComponent');
    if (this.consultationSession) {
      this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'incomplete-chat-popup-rebranded' }), PRIMARY_CHANNELS);
    }
  }

  openInstruction(regimenClass: string): void {
    this.eventLogger.trackEvent('INSTRUCTION_BANNER_CLICKED');
    this.router.navigate(['/user'], { queryParams: { tab: 'regimen', class: regimenClass } });
  }

  async checkLastDeliveredOrder(): Promise<void> {
    if (!this.latestOrder) return;
    const deliveredDate = new Date(this.latestOrder?.get('deliveredOn'));
    const differenceBetweenCurrentDateAndDeliveryDate = this.timeService.differenceInDays(new Date(), deliveredDate);
    if (differenceBetweenCurrentDateAndDeliveryDate > 7) {
      return;
    }
    this.showDeliveredBanner = true;
  }

  getKitImage(): string {
    const faceRegimen = this.appConfig.Shared.Regimen.Class.FACE;
    const classOfRegimen = this.latestOrder?.get('regimen')?.get('class') || faceRegimen;
    if (classOfRegimen === faceRegimen) return 'https://cdn.cureskin.com/app/img/Skin-Box.png';
    return 'https://cdn.cureskin.com/app/img/Hair-Box.png';
  }

  async checkFollowUpReportAvailable(): Promise<void> {
    if (this.skipExecutionForUnpaidUser) return;
    [this.followUpReport] = await this.conn.fetchFollowUpReports({
      where: {
        user: this.user,
        createdAt: { $gte: new Date(new Date().getTime() - 604800000) }, // 7 * 24 * 60 * 60 * 1000
        read: { $ne: true },
      },
      descending: 'createdAt',
      limit: 1,
    });
  }

  async fetchSupportTickets(): Promise<any> {
    if (this.skipExecutionForUnpaidUser) return;
    const { user }: any = this;
    const payload = { where: { user } };
    const ticket: any = await this.conn.fetchLatestActiveSupportTickets(payload);
    const ticketObj: any = JSON.parse(JSON.stringify(ticket));
    if (ticketObj.cacheSupportChat
      && ticketObj.attended
      && new Date(ticketObj.lastVisited?.iso) < new Date(ticketObj?.latestResponseTimeFromInternalUser.iso)) {
      ticketObj.hasUnreadMessage = true;
    }
    this.supportTicket = ticketObj;
    if (ticketObj?.hasUnreadMessage) {
      const payloadOne = { where: { user, supportTicket: ticket } };
      const chat = await this.conn.fetchSupportChat(payloadOne);
      if (chat[chat.length - 2]?.get('Inputs')?.length) {
        this.requestDataInTicket = true;
      } else {
        this.replyInTicket = true;
      }
      this.userDoctor = await this.userAllocatedDoctorService.getDoctorById(this.supportTicket.allocatedDoctor.objectId);
    }
  }

  async fetchResolvedDiscomfortSupportTicket(): Promise<any> {
    if (this.skipExecutionForUnpaidUser) return;
    const { user }: any = this;
    const payload = { where: { user,
      allocatedDoctor: { $exists: true },
      status: { $ne: this.appConfig.Shared.Ticket.status.Pending },
      feedback: { $exists: false },
      'llmResponse.category': 'discomfort' } };
    const ticket: any = await this.conn.fetchLatestActiveSupportTickets(payload);
    this.activeDiscomfortTicket = JSON.parse(JSON.stringify(ticket));
      const payloadOne = { where: { user, supportTicket: ticket, trackingDetails: { $exists: false } } };
      const chat = await this.conn.fetchSupportChat(payloadOne);
    if(chat[chat.length - 1]?.get('Mode') === this.appConfig.Shared.Assistant.Mode.AUDIO) {
      this.audioMessageInTicket = chat[chat.length - 1];
      this.updateDiscomfortBannerVisibility();
  }
    this.isDiscomfortVoiceNoteBannerActive = true;
  }

  async fetchPendingDiscomfortSupportTicket(): Promise<any> {
    if (this.skipExecutionForUnpaidUser) return;
    const { user }: any = this;
    const payload = { where: { user,
      allocatedDoctor: { $exists: true },
      PrivateTreeCompleted: true,
      status: this.appConfig.Shared.Ticket.status.Pending,
      feedback: { $exists: false },
      'llmResponse.category': 'discomfort' } };
    const ticket: any = await this.conn.fetchLatestActiveSupportTickets(payload);
    this.pendingDiscomfortTicket = JSON.parse(JSON.stringify(ticket));
    this.isDiscomfortBannerActive = true;
  }

  openFollowUpReport(): void {
    this.eventLogger.trackEvent('FOLLOWUP_REPORT_BANNER_CLICKED', { id: this.followUpReport.id });
    this.router.navigate([`/user/report/${this.followUpReport.id}`]);
  }

  async openConsultation(origin?: string): Promise<void> {
    if (origin === 'bottom_sheet') {
      this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'incomplete-chat-banner' }));
    } else {
      this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'chat_incomplete_carousel_banner_clicked' }));
    }
    try {
      await this.conn.switchUserToState(
        `v4_${this.consultationSession?.get('PrivateMainConcernClass').toLowerCase()}:`,
        { consultationSessionId: this.consultationSession.id });
    } catch (error) {
      this.eventLogger.trackEvent('ERROR_switchUserToState', { error: error, consultationSessionId: this.consultationSession.id, from:'incomplete-chat-bottomsheet' });
    }
    await this.router.navigate([`/chatV2/${this.consultationSession.id}`], {
      queryParams: { type: 'consultationSession', back: 'home' },
    });
  }

  openDiet(from?: string): void {
    if (from === 'lastLevelDietBanner') {
      this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'diet_last_level_banner' }));
    } else {
      this.eventLogger.cleverTapEvent('diet_banner_rebranded', '{}', [
        this.appConfig.Shared.EventTracker.CLEVER_TAP,
        this.appConfig.Shared.EventTracker.MOENGAGE,
        this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
      ]);
      this.eventLogger.trackEvent('diet_banner_rebranded');
    }

    this.router.navigate(['/notice']);
  }

  openGame(isRebranded?: boolean): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'new-quiz-game', ...(isRebranded && { isRebranded: true }) }), [
      this.appConfig.Shared.EventTracker.CLEVER_TAP,
      this.appConfig.Shared.EventTracker.MOENGAGE,
      this.appConfig.Shared.EventTracker.AMPLITUDE,
      this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
    ]);
    this.router.navigate(['/quiz-game']);
  }

  // Note: on logging something, it runs infinite. needs to check
  ngAfterViewChecked(): void {
    this.appBridge.setStatusBarColor('cure/light');
    const params = this.route.snapshot.queryParams;
    const { section }: any = params;
    const windowRef = this.windowRef.nativeWindow;
    const doc = windowRef.document;
    const scrollDiv = doc.getElementById(section);
    if (scrollDiv) {
      scrollDiv.scrollIntoView({ behavior: 'smooth' });
    }
    this.updateSwiperAutoScroll();
    this.updateSwiperAutoScrollOne();
    this.updateSwiperAutoScrollTwo();
  }

  async fetchUserFollowUp(): Promise<void> {
    if (this.skipExecutionForUnpaidUser) return;
    await this.followUpService.fetchPendingFollowups();
    if (!this.followUp()) {
      this.resolveFollowupQuestionsWidget();
      return;
    }
    if (this.selfCheckupPhotoExperiment) {
      this.determineSelfCheckupFlow();
    } else {
      this.selfCheckupWindowDetermined = true;
    }
    this.selectedFollowUpBanner = this.decideFollowUpCard();
    this.resolveFollowupQuestionsWidget();
    const followUpDoctorId = this.followUp()?.get('allocatedDoctor')?.id;
    if (followUpDoctorId) {
      this.followUpDoctor = await this.userAllocatedDoctorService.getDoctorById(followUpDoctorId);
    }
    let showAnytimeFollowupPopup$;
    this.store.select(fromSelectors.selectHomePageState).subscribe((data: any): void => {
      showAnytimeFollowupPopup$ = data.showAnytimeFollowupPopup;
    });
    if (['followUpScheduledInTwoDays', 'anyTimeFollowUpEnabled', 'lastFollowUpSkipped'].includes(this.selectedFollowUpBanner)
      && showAnytimeFollowupPopup$) {
      this.bottomSheetPriority.push('AnytimeFollowupComponent');
    }
    this.store.dispatch(fromActions.HomePageUpdate({ showAnytimeFollowupPopup: false }));

    // Prefetch initial instant-checkup image for ActiveCheckupBottomsheet (experiment gated)
    const checkupRegimen = this.getActiveCheckupRegimen();
    if (this.isCheckupBsHomepageExperimentEnabled && checkupRegimen?.deliveredDate) {
      this.instantCheckupService.getUserInitialInstantCheckupImage(this.user?.id, checkupRegimen, checkupRegimen.class).catch((): void => {});
    }
  }

  private async resolveFollowupQuestionsWidget(): Promise<void> {
    this.canShowFollowupQuestionsWidget.set(false);

    await this.experimentService.experimentsLoaded;
    if (!this.experimentService.isFupQuestionsNewUiEnabled()) return;

    if (this.selectedFollowUpBanner !== 'followUpReadyWaitingForReport') return;
    if (this.festivalDelayBannerEnabled) return;

    const pending = this.followUpService.pendingFollowup();
    if (!pending) return;
    if (pending.get('followUpCount') !== 1) return;

    if (this.localStorageService.getValue('fupQuestionsActive') !== pending.id) return;

    this.canShowFollowupQuestionsWidget.set(true);
  }

  onFollowupQuestionsCompleted(): void {
    this.canShowFollowupQuestionsWidget.set(false);
    this.followUpService.fetchPendingFollowups().catch((): void => {});
  }

  onFollowupQuestionsFallback(): void {
    const pending = this.followUpService.pendingFollowup();
    const followUpId = pending?.id;
    this.canShowFollowupQuestionsWidget.set(false);
    if (followUpId) {
      this.router.navigate([`/chatV2/${followUpId}`], { queryParams: { type: 'followUp' } });
    }
  }

  get followupQuestionsWidgetImage(): string | undefined {
    return this.instantCheckupService.getUserLatestImage(this.instantCheckups as any);
  }

  private getActiveCheckupRegimen(): any | undefined {
    const variant = this.checkupBsHomepageVariant;
    if (variant.face && variant.hair) {
      return this.faceRegimenOrderDelivered || this.hairRegimenOrderDelivered;
    }
    if (variant.face && !variant.hair) {
      return this.faceRegimenOrderDelivered;
    }
    if (variant.hair && !variant.face) {
      return this.hairRegimenOrderDelivered;
    }
    return undefined;
  }

  private getDaysSinceActiveRegimenDelivery(regimen: any): number | undefined {
    const deliveredDateRaw = regimen?.deliveredDate;
    if (!deliveredDateRaw) return undefined;
    const deliveredDate = new Date(deliveredDateRaw);
    return this.timeService.differenceInDays(new Date(), deliveredDate);
  }

  private async openActiveCheckupBottomSheet(): Promise<boolean> {
    try {
      const activeRegimen = this.getActiveCheckupRegimen();
      if (!activeRegimen) return false;

      const userInitialImagePath = await this.instantCheckupService
        .getUserInitialInstantCheckupImage(this.user?.id, activeRegimen, activeRegimen.class);

      const bottomSheetRef = this.bottomSheet.open(ActiveCheckupBottomsheetComponent, {
        data: {
          userFirstName: this.userFirstName,
          userInitialImagePath,
          daysSinceRegimenDelivery: this.getDaysSinceActiveRegimenDelivery(activeRegimen),
          onTakeCheckupNow: (): void => {
            this.startFollowUp('CHECKUP_BS_HOMEPAGE_TAKE_CHECKUP');
          },
          onSkip: (): void => {
            // No-op: user is already on homepage, no navigation needed
          },
        },
        backdropClass: 'bottomsheet-blur-overlay-sm',
      });

      bottomSheetRef.afterDismissed().subscribe((result?: string): void => {
        const dismissalReason = result || 'backdrop_click';
        this.eventLogger.cleverTapEvent('click', JSON.stringify({
          name: 'checkup_bs_homepage_dismissed',
          dismissalReason,
        }));
      });

      return true;
    } catch (e) {
      return false;
    }
  }

  private decideFollowUpCard(): 'followUpScheduled' | 'followUpScheduledInTwoDays' | 'followUpReadyWaitingForReport'
    | 'followUpWaitingForImage' | 'anyTimeFollowUpEnabled' | 'lastFollowUpSkipped' | 'followUpReportIsReady' {
    switch (this.followUp()?.get('State')) {
      case this.appConfig.Shared.Followup.State.WAITING_FOR_IMAGE: {
        return 'followUpWaitingForImage';
      }
      case this.appConfig.Shared.Followup.State.PENDING: {
        if (this.followUp()?.get('ready')) {
          return 'followUpReadyWaitingForReport';
        }
        if (this.timeService.differenceInDays(this.followUp()?.get('nextFollowUpDate'), new Date()) <= 2) {
          return 'followUpScheduledInTwoDays';
        }
        if (this.followUp()?.get('isPreviousFollowUpSkipped')) {
          return 'lastFollowUpSkipped';
        }
        if (this.followUp()?.get('isAnytimeFollowUpEnabled')) {
          return 'anyTimeFollowUpEnabled';
        }
        return 'followUpScheduled';
      }
      default: return 'followUpScheduled';
    }
  }

  private resolveFollowUpReportType(): FollowUpReportType {
    const regimens: Array<any> = this.followUp()?.get('regimens') ?? [];
    const classes = new Set(regimens.map((regimen): string => regimen?.get?.('class')));
    const hasFace = classes.has(this.appConfig.Shared.Regimen.Class.FACE);
    const hasHair = classes.has(this.appConfig.Shared.Regimen.Class.HAIR);
    if (hasFace && hasHair) return FollowUpReportType.SKIN_HAIR;
    if (hasHair) return FollowUpReportType.HAIR;
    return FollowUpReportType.SKIN;
  }

  async checkForUnreadNotifications(): Promise<void> {
    const unreadNotifications: number = await this.conn.findUnReadNotifications();
    if (unreadNotifications > 0) {
      this.unreadNotifications = true;
      this.toolbarIcons[0].notify = true;
    }
  }

  async fetchRegimens(): Promise<any> {
    const include: ParseKeys<Table.Regimen>[] = [
      'variants.morning.product.heroIngredients' as 'variants',
      'variants.night.product.heroIngredients' as 'variants',
      'morning.product.heroIngredients',
      'night.product.heroIngredients',
      'regimenTag',
    ] as ParseKeys<Table.Regimen>[];
    this.regimens = await this.conn.fetchRegimens(null, true, true, include);

    if (this.regimens && this.regimens.length) {
      this.latestUnBoughtRegimen = this.regimens.find((regimen: AllocatedRegimen): boolean => !(regimen.orderPlaced || regimen.delivered));
      this.latestUnDelivereRegimen = this.regimens.find((regimen: AllocatedRegimen): boolean => regimen.orderPlaced && !regimen.delivered);
      this.faceRegimenOrderPlaced = this.regimens.find((regimen: AllocatedRegimen): boolean => (regimen.orderPlaced && !regimen.active)
        && regimen.class === this.appConfig.Shared.Regimen.Class.FACE);
      this.latestActiveRegimen = this.regimens.find((regimen: AllocatedRegimen): boolean => regimen.active && regimen.delivered);
      this.faceRegimenOrderDelivered = this.regimens.find((regimen: AllocatedRegimen): boolean => regimen.delivered
        && regimen.class === this.appConfig.Shared.Regimen.Class.FACE);
      this.hairRegimenOrderDelivered = this.regimens.find((regimen: AllocatedRegimen): boolean => regimen.delivered
        && regimen.class === this.appConfig.Shared.Regimen.Class.HAIR);
    }
    this.regimensClass = this.regimens.map((each: AllocatedRegimen): string => each.class);
  }
  /**
   * Check for user status, whether he/she is PAID | GOT_REGIMEN | NO_PHOTO.
   * 1. PAID - if any regimen order is placed or delivered
   * 2. GOT_REGIMEN - if any regimen is allocated or in preparation time.
   * 3. NO_PHOTO - if none of the above.
   */
  findUserStatus(): any {
    this.userStatus = { PAID: false, GOT_REGIMEN: false, NO_PHOTO: false };
    const regimenOrderPlaced: boolean = this.regimens?.some((each: AllocatedRegimen): boolean => !!(each.orderPlaced || each.delivered)) ?? false;
    if (this.latestUnBoughtRegimen) {
      this.isRegimenBeingPrepared = this.commonUtil.isRegimenBeingPrepared(this.latestUnBoughtRegimen);
    }
    if (this.user?.get('orderState') === 'DELIVERED') this.userStatus.PAID = true;
    // commented for now, can be removed later
    // if (this.user.isPaid() || regimenOrderPlaced) this.userStatus.PAID = true;
    else if (this.latestUnBoughtRegimen && !this.isRegimenBeingPrepared) this.userStatus.GOT_REGIMEN = true;
    else this.userStatus.NO_PHOTO = true;
  }

  goToCart(): void {
    this.eventLogger.cleverTapEvent('cartClicked', JSON.stringify({ name: 'home' }));
    this.router.navigate(['cart']);
  }

  private setAcqShopBannerVisibility(): void {
    const eligible = this.shopService.shouldShowAcqShopBanner(this.user, this.regimens);
    const productCardsVariant = eligible && this.shopService.shouldShowAcqShopProductCards();
    this.showAcqShopBanner = eligible && !productCardsVariant;
    this.showAcqShopProductsBanner = eligible && productCardsVariant;
  }

  async getCart(): Promise<void> {
    // Parallel-fetch: new cart API for language-aware lineItems (powers complete-your-order banners),
    // legacy getCart cloudRun for recommendedProducts (not yet on the new API; powers suggested-for-you).
    const [newCart, legacyCart] = await Promise.all([
      this.conn.fetchNewCart(this.user.id),
      this.conn.getCart(),
    ]);
    this.cart = newCart?.data;
    this.cartItems = this.cart?.lineItems ?? [];
    this.recommendedItems = legacyCart?.get('recommendedProducts');
    // Recompute every refresh so it doesn't latch true and permanently suppress the cart banner.
    this.showSuggestedForYouBanner = !!this.recommendedItems?.length;
    // The new cart API's lineItems don't carry the doctor voice-note script fields
    // (isAddedByScript / scriptAudioUrl / createdAt). The legacy cart still does, so merge
    // them onto the new lineItems (matched by productId) to keep the voice-note banner and
    // the script-added header variants of the complete-your-order banners working.
    this.mergeScriptFieldsFromLegacyCart(legacyCart?.get('lineItems'));
    this.productsInCart = [];
    if (this.cartItems.length) {
      this.addBanner('cartItems');
      this.toolbarIcons[1].cart = true;
      let totalItems: number = 0;
      this.cartItems.forEach((element: any): void => {
        totalItems += element.quantity;
        this.productsInCart.push(element);
      });
      this.toolbarIcons[1].cartValue = totalItems || null;
    } else {
      this.removeBanner('cartItems');
      this.toolbarIcons[1].cart = false;
      this.toolbarIcons[1].cartValue = null;
    }
    this.fetchDiscount();

    // Dispatch cart update to Redux store for synchronization
    const cartProductQuantities: { [key: string]: number } = {};
    this.cartItems.forEach((item: any) => {
      cartProductQuantities[item.productId] = Number(item.quantity) || 0;
    });
    this.store.dispatch(fromActions.CartUpdateProductsBegin({
      products: cartProductQuantities
    }));
  }

  fetchDiscount(): any {
    this.totalMRP = 0;
    this.totalSP = 0;
    this.cartItems.forEach((element: any): any => {
      this.totalSP += element.quantity * element.price;
      this.totalMRP += element.quantity * element.mrp;
    });
    this.totalMRP = Math.round(this.totalMRP);
    this.totalSP = Math.round(this.totalSP);
    if (this.showCashBalance && !(this.experimentService.applyCashExperiment && this.user?.get('orderState') === this.appConfig.Shared.User.OrderState.DELIVERED)) {
      // When applyCashExperiment is on and user's orderState is DELIVERED, Buy Now CTA should show amount without deducting Cureskin Cash
      this.cashDiscount = Math.min(this.totalCashBalance, this.totalSP);
      this.totalSP -= this.cashDiscount;
    }
    let discount = 0;
    this.totalMRP = Math.floor(this.totalMRP);
    if (this.totalMRP > this.totalSP) {
      discount = Math.floor(((this.totalMRP - this.totalSP) * 100) / this.totalMRP);
    }
    this.cartDiscount = discount;
  }

  async fetchFaqs(): Promise<any> {
    let faqs = this.dataStore?.get('FAQS');
    if (!faqs.categories) faqs = await this.conn.fetchFAQ();
    this.faqs = faqs;
    this.dataStore.set('FAQS', faqs);
  }

  notificationClickAction(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'home-notification' }));
    this.openURL('/user/notifications');
  }

  referBannerClick(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'refer_last_level_banner' }));
    this.navigateTo('/user/refer');
  }

  testimonialsClick(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'home-testimonials' }));
    this.navigateTo('/article/QvKJWYZyBB');
  }

  analysisOfTheDay(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'home-skin-analysis-of-the-day' }));
    this.navigateTo('/user/instantCheckup');
  }

  openBlog(blog: any): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'home-blog-article' }));
    this.navigateTo(blog.url);
  }

  optedForSupport(mode: any): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: `home-support-${mode}` }));
  }

  knowAboutDoctors(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'home-know-about-doctors' }));
    this.navigateTo('/doctors');
  }


  async fetchBlog(): Promise<any> {
    if (this.skipExecutionForUnpaidUser) return;
    this.blogs$ = this.store.select(fromSelectors.selectHomePageBlogs).pipe(map((blogs: object[]): object[] => (
      blogs.map((each: any): any => ({ image: each.thumbnailURL, url: each.contentURL, createdAt: each.createdAt }))
    )));
    const payload = { where: { user: this.user }, descending: 'createdAt', limit: this.conn.isInternalUser() ? 100 : 5 };
    this.store.dispatch(fromActions.HomePageBlogsBegin({ payload }));
  }

  enableNgClassCondition(): boolean {
    return [this.appConfig.Shared.Languages.ML, this.appConfig.Shared.Languages.KN, this.appConfig.Shared.Languages.TE,
      this.appConfig.Shared.Languages.TA].includes(this.user.get('languagePreference'));
  }

  /**
   * Fetches more content based on user state.
   * 1. PAID - fetches addon products, reorder products, & checks for pending followup banner
   * 2. If any regimen is allocated and unbought, a banner shown to buy it
   * 3. Fetches faqs, Notifications, Cureskin cash calim banner if any order has unclaimed rewards.
   * Re-arranges cards based on user state.
   */
  async fetchOtherDataBasedOnUserState(): Promise<void> {
    setTimeout((): void => {
      this.loading = false;
    });
    await this.fetchFaqs();
    await this.checkForUnreadNotifications();
    if (this.latestUnBoughtRegimen && !this.isRegimenBeingPrepared) this.showUnBoughtRegimen = true;
  }

  private evaluatePaymentDropOffBanner(orders: Array<Table.Order> | null | undefined): void {
    if (this.user && this.userService.isPaidUser(this.user)) {
      this.paymentDropOffOrders = [];
      return;
    }
    const currentRegimenIds = new Set((this.regimens || []).map((regimen: AllocatedRegimen): string => regimen.objectId));
    this.paymentDropOffOrders = (orders || []).filter((order: Table.Order): boolean => (
      typeof order?.get === 'function'
        && order.get('type') === this.appConfig.Shared.Order.Type.REGIMEN
        && currentRegimenIds.has(order.get('regimen')?.id)
    ));
  }

  async getInitialOrderDetails(): Promise<Array<Table.Order>> {
    const where: any = { user: this.user };
    const select: Array<ParseKeys<Table.Order>> = ['orderNumber', 'type', 'amount', 'stage', 'regimen',
      'productInfo', 'createdBy', 'actualCreatedAt'];
    const stages = [
      this.appConfig.Shared.Order.Stage.ONLINE_PAYMENT_PENDING,
      this.appConfig.Shared.Order.Stage.INITIAL,
    ];
    where.stage = { $eq: stages };
    try {
      const orders = await this.conn.fetchOrders(where,
        select,
        ['products', 'services', 'regimen', 'regimen.products' as 'regimen', 'coupons', 'user', 'createdBy'],
      );
      this.userActiveOrders.update((prevOrders) => [...prevOrders, ...(orders || [])]);
      orders.forEach(async (element: any): Promise<any> => {
        this.order = await this.conn.findOrderWithSignedURL(element.id);
        if (this.drOrderBannerHome) {
          if (this.order?.amount) {
            this.order.discount = Math.floor(((this.order.actualPrice - this.order.amount) * 100)
              / this.order.actualPrice);
          }
        }
        const isDietOrder = this.order?.serviceInfo?.some((service: any): any => service.type
          === this.appConfig.Shared.Order.Type.DIET_CONSULTATION);
        if (this.order && !isDietOrder && this.order?.type !== this.appConfig.Shared.Order.Type.REGIMEN) {
          if (this.drOrderBannerHome) {
            if (this.order?.createdBy?.type) {
              this.addBannerOne(this.order);
            }
          } else {
            this.addBannerOne(this.order);
          }
        }
      });
      return orders || [];
    } catch (error) {
      this.eventLogger.logError(error);
      return [];
    }
  }

  openBanner(banner: any = {}): void {
    this.eventLogger.trackEvent('home_banner_click', { url: banner.link });
    if (banner.link) this.navigateTo(banner.link);
  }

  openFaq(category: string): void {
    if (!this.faqs.categories) return;
    const faq = this.faqs.categories.find((each: any): boolean => each?.get('category') === category);
    if (faq) {
      this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: `home-faq-option-${faq.id}` }));
      this.navigateTo(`/faq/${faq.id}`);
    }
  }

  trackEventAndNavigateTo(eventName: string, url?: string): void {
    this.eventLogger.trackEvent(eventName);
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: `home-${eventName}` }));
    this.navigateTo(url);
  }

  navigateTo(url: string = ''): void {
    if (!url) return;
    const queryParams: Record<string, any> = {};
    const [URL, qParamString]: string[] = url.split('?');
    if (qParamString) {
      qParamString.split('&').forEach((each: string): void => {
        const [key, value]: string[] = each.split('=');
        queryParams[key] = value;
      });
    }
    this.eventLogger.trackEvent('home_page_url_open', { url });
    this.router.navigate([URL], { queryParams });
  }

  toggleMenu(status: boolean): void {
    this.zone.run((): void => {
      this.isMenuOpen = status;
      if (!status) this.tryOpenIncompleteChatSheet();
    });
  }

  swipeCoordinates(data: any): void {
    const { direction, startXPos }: any = JSON.parse(data);
    const MAX_INITIAL_X_POSITION = 50;
    if (direction === 'RIGHT' && !this.isMenuOpen && Number(startXPos) <= MAX_INITIAL_X_POSITION) this.toggleMenu(true);
    if (direction === 'LEFT' && this.isMenuOpen) this.toggleMenu(false);
  }

  buyRegimen(concernClass: string): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: `home-buy-${concernClass}` }));
    if (concernClass) {
      this.navigateTo(`/user?tab=regimen&class=${concernClass}`);
    } else {
      this.navigateTo('/user?tab=regimen');
    }
  }

  async refreshUserStatus(): Promise<any> {
    if (this.userStatus.PAID) return;
    await this.fetchRegimens();
    this.findUserStatus();
  }

  /**
   * If tab is inactive - i.e if we retain the tab in dom even if navigated to other tab. then we perform inactive state operation
   * (Note: we retained home tab in dom previously by translateX(-100%) when navigated to some other tab.
   *  Now its hidden. This code is not useful).
   * 1. Closes Navigation drawer menu if opened
   * 2. Scrolls home page to top
   * Sets the component to currentComponentService
   * Checks for change in user state and populates the data based on that.
   */
  async refreshComponent(): Promise<void> {
    if (!this.isTabActive) {
      if (this.isMenuOpen) this.toggleMenu(false);
      if (this.homePageContainer && this.homePageContainer?.nativeElement) this.homePageContainer.nativeElement.scrollTop = 0;
      return;
    }
    this.makeComponentActive(true);
    if (this.user) {
      await this.refreshUserStatus();
      this.loadLatestDeliveredOrder();
      this.loadLanguageBannerContent();
    }
  }

  shareTip(): void {
    this.broadcast.broadcast('SHARE', { type: 'IMAGE', url: this.tipOfDay?.get('image') });
  }

  /**
   * Handles back press locallay on folowing conditions
   * 1. if any popup is opened or Navigation drawer is opened
   * 2. else returns false and browser handles it
   */
  async handleBackPress(): Promise<boolean> {
    if (this.isMenuOpen) {
      this.toggleMenu(false);
      return true;
    }
    return false;
  }

  /**
   * Sets the component in currentComponentService based on status parameter.
   * If there is any multi layered popup and the any of popup needs to handle back press,
   * then we call this function to switch the status of component based on need.
   * @param {boolean} status -
   */
  makeComponentActive(status: boolean): void {
    if (status) this.currentComponentService.set(this);
    else this.currentComponentService.remove(this);
  }

  back(): void {
    this.broadcast.broadcast('NAVIGATION_BACK');
  }

  stopPropagation(event: any): void {
    event.stopPropagation();
  }

  viewAll(pageName: string): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: `view-all-${pageName}` }));
    this.conn.navigateToURL(`/user/order/reorder?from=${pageName}`);
  }

  openURL(url: string): void {
    this.conn.navigateToURL(url);
  }

  redirectToArticle(): void {
    this.navigateTo(`/article/${this.redirectArticleId}`);
  }

  startLiveSession(sessionId: string): void {
    if (this.appWebBridgeService.isAppWebBridgeLoaded()) {
      this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'Doctor-Live-Session-Open' }));
      this.appWebBridgeService.startLiveSession(sessionId);
    } else {
      this.router.navigate(['/user/live-session']);
    }
  }

  private addBanner(bannerName: string): void {
    // Already present → nothing changed; skip the swiper re-churn (avoids sticky/banner flicker on
    // every cart refresh, e.g. repeated add/minus from a product section).
    if (this.bannerContainer.includes(bannerName)) {
      return;
    }
    this.bannerContainer.push(bannerName);
    this.bannerContainer.sort((banner1: string, banner2: string): number => {
      if (UserHomeComponent.BannerOrder[banner1] === UserHomeComponent.BannerOrder[banner2]) {
        return 0;
      }
      if (UserHomeComponent.BannerOrder[banner1] > UserHomeComponent.BannerOrder[banner2]) {
        return 1;
      }
      return -1;
    });
    this.updateSwiperAutoScroll();
  }

  private removeBanner(bannerName: string): void {
    const index = this.bannerContainer.indexOf(bannerName);
    if (index === -1) {
      return;
    }
    this.bannerContainer.splice(index, 1);
    this.updateSwiperAutoScroll();
  }

  // Review for usage
  /*
  1. if kit ready banner is there in the home page
  2. kit is ready banner index
  */
  onSlideChange2(swiper: Swiper): void {
    if (swiper) {
      swiper.update();
    }
    // if (swiper && (swiper.activeIndex === this.skinBannerIndex || swiper.activeIndex === this.hairBannerIndex)) {
    //   this.resetKitReadyBannerHeight = false;
    // } else {
    //   this.resetKitReadyBannerHeight = true;
    // }
  }

  onSlideChange(event: any): void {
    this.activeBannerIndex = event[0].snapIndex - 1;
    if (this.activeBannerIndex >= this.bannerContainer.length || this.activeBannerIndex < 0) {
      this.activeBannerIndex = 0;
    }
    this.changeDetectorRef.detectChanges();
  }
  onSlideChangeOne(event: any): void {
    this.activeBannerIndexOne = event[0].snapIndex - 1;
    if (this.activeBannerIndexOne >= this.bannerContainerOne.length || this.activeBannerIndexOne < 0) {
      this.activeBannerIndexOne = 0;
    }
    this.changeDetectorRef.detectChanges();
  }
  onSlideChangeTwo(event: any): void {
    this.changeDetectorRef.detectChanges();
  }

  private updateSwiperAutoScroll(): void {
    if (this.bannerContainer.length && !this.stickyBarsSubscribed) {
      this.stickyBarsSubscribed = true;
      this.subscriptions.push(
        this.store.select(fromSelectors.selectHomePageState).subscribe((data: any): void => {
          this.showStickyBars$ = data.isSessionOn;
        }),
      );
    }
    if (!this.swiper?.swiperRef) {
      return;
    }
    const swiper = this.swiper.swiperRef;
    if (this.bannerContainer.length <= 1) {
      swiper.updateAutoHeight();
      swiper?.autoplay?.stop();
      swiper.allowTouchMove = false;
      return;
    }
    swiper.updateAutoHeight();
    swiper.allowTouchMove = true;
    this.swiper?.swiperRef?.autoplay?.start();
  }

  private updateSwiperAutoScrollOne(): void {
    if (!this.swiperOne?.swiperRef) {
      return;
    }
    const swiper = this.swiperOne.swiperRef;
    if (this.bannerContainerOne.length <= 1) {
      swiper.updateAutoHeight();
      swiper?.autoplay?.stop();
      swiper.allowTouchMove = false;
      return;
    }
    swiper.updateAutoHeight();
    swiper.allowTouchMove = true;
    this.swiperOne.swiperRef?.autoplay?.start();
  }

  private updateSwiperAutoScrollTwo(): void {
    if (!this.swiperTwo?.swiperRef) {
      return;
    }
    const swiper = this.swiperTwo.swiperRef;
    if (this.bannerContainerTwo.length <= 1) {
      swiper.updateAutoHeight();
      swiper?.autoplay?.stop();
      swiper.allowTouchMove = false;
      return;
    }
    swiper.updateAutoHeight();
    swiper.allowTouchMove = true;
    this.swiperTwo.swiperRef?.autoplay?.start();
  }

  private addBannerTwo(banner: any): void {
    this.bannerContainerTwo.push(banner);
    this.updateSwiperAutoScrollTwo();
  }

  private addBannerOne(banner: any): void {
    if (!this.bannerContainerOne.includes(banner.id)) {
      this.bannerContainerOne.push(banner);
    }
    this.updateSwiperAutoScrollOne();
  }
  // End of review

  trackEvent(event: string): void {
    this.eventLogger.trackEvent(event, { id: this.followUp().id });
  }

  async trackVoiceEvent(swiperCardsBanner: any, action: any): Promise<void> {
    switch (action) {
      case 'play': {
        await this.onAudioPlay();
        swiperCardsBanner?.swiperRef?.autoplay?.stop();
        break;
      }
      case 'completed': {
        await this.onAudioPlayEnd();
        swiperCardsBanner?.swiperRef?.autoplay?.start();
        break;
      }
      default:
    }
  }

  async trackVoiceEventDiscomfortTicket(action: any): Promise<void> {
    switch (action) {
      case 'play': {
        this.eventLogger.cleverTapEvent('audioPlayed',
          JSON.stringify({
            supportTicketId: this.activeDiscomfortTicket.id,
            pageName: 'home',
            voiceNote: this.audioMessageInTicket.get('Metadata')?.split('audioPath=')[1]
          }), [
            this.appConfig.Shared.EventTracker.MIXPANEL,
            this.appConfig.Shared.EventTracker.AMPLITUDE,
            this.appConfig.Shared.EventTracker.CLEVER_TAP,
            this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
          ]
        );
      await this.conn.trackVoiceNotesAndScrollEvents({ objectId: this.audioMessageInTicket.id,
        eventName: 'audioPlayed',
        trackingTable: 'supportChat' });
        break;
      }
      case 'completed': {
        this.eventLogger.cleverTapEvent('audioFinished',
        JSON.stringify({
          supportTicketId: this.activeDiscomfortTicket.id,
          pageName: 'home',
          voiceNote: this.audioMessageInTicket.get('Metadata')?.split('audioPath=')[1]
        }), [
          this.appConfig.Shared.EventTracker.MIXPANEL,
          this.appConfig.Shared.EventTracker.AMPLITUDE,
          this.appConfig.Shared.EventTracker.CLEVER_TAP,
          this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
        ]);
        await this.conn.trackVoiceNotesAndScrollEvents({ objectId: this.audioMessageInTicket.id,
          eventName: 'audioFinished',
          trackingTable: 'supportChat' });
        break;
      }
      default:
    }
  }

  async fetchOrderChat(): Promise<void> {
    const where = {
      user: this.user,
      Mode: 'AUDIO',
      Owner: 'DOCTOR',
      createdAt: { $gte: this.timeService.removeDays(new Date(), 5) },
      $or: [
        { trackingDetails: { $exists: false } },
        { 'trackingDetails.audioFinished': { $exists: false } },
        { 'trackingDetails.audioFinished': false },
      ],
    };
    this.notListenedVoiceMessage = await this.conn.findOneOrderChat({
      where,
      ascending: 'createdAt',
      include: ['order'],
      option: { context: { translate: true } } as Parse.FullOptions,
    });
    if (this.notListenedVoiceMessage) {
      this.showVoiceNoteBanner = this.shouldShowExpectationVoiceNoteBanner({
        orderStage: this.notListenedVoiceMessage.get('order').get('stage'),
        selectedFollowUpBanner: this.selectedFollowUpBanner,
        questionId: this.notListenedVoiceMessage.get('questionId'),
      })
      await this.getRegimenCoverImageUrl();
      this.isDoctorVerifiedKit = this.notListenedVoiceMessage
        ?.get('questionId') === 'aVoiceMessageFromDoctor'; // this is the questionId that comes after order approval
      this.voiceNoteBannerDetails.voiceUrl = this.notListenedVoiceMessage?.get('audioUrl');
      this.voiceNoteBannerDetails.trackEventAudio = {
        event: 'AudioMessageSendDuringApprovalOpen',
        data: {
          orderChatId: this.notListenedVoiceMessage.id,
          orderId: this.notListenedVoiceMessage?.get('order').id,
        },
      };
      this.voiceNoteBannerDetails.doctorDisplayImageURL = this.userDrImage;
      this.voiceNoteBannerDetails.doctorName = this.allocatedDoctor?.DoctorDisplayName;
      this.voiceNoteBannerDetails.message = this.notListenedVoiceMessage?.get('Message');
    }
  }

  async refreshVoiceNote(): Promise<void> {
    this.showVoiceNoteBanner = false;
    await this.fetchOrderChat();
    setTimeout(() => { this.showVoiceNoteBanner = !!this.notListenedVoiceMessage; });
  }

  private shouldShowExpectationVoiceNoteBanner(params: {
    orderStage: any,
    selectedFollowUpBanner: string,
    questionId: string,
  }) : boolean {
    const isOrderInCancelledStages = this.appConfig.Shared.Order.Stage.orderCanceledStages.includes(params.orderStage);
    const isTwoWeekExpectationVoiceNote = params.questionId === 'regimenFollowUpTitle|regimenFollowUpMessage';
    const isFirstFollowUp = this.followUp()?.get('followUpCount') === 1;
    const isRestrictedBanner = ['followUpReadyWaitingForReport'].includes(params.selectedFollowUpBanner);
    let shouldShowBanner = true;
    if (isOrderInCancelledStages) {
      shouldShowBanner = false;
    }
    else if (isTwoWeekExpectationVoiceNote) {
      shouldShowBanner = !this.disableTwoWeekExpectationVoiceNoteExp &&
        !isRestrictedBanner &&
        isFirstFollowUp;
    }
    return shouldShowBanner;
  }

  async getRegimenCoverImageUrl(): Promise<void> {
    const order = this.notListenedVoiceMessage?.get('order');
    const regimen = order?.get('regimen');
    const regimenId = regimen?.id;

    if (regimenId) {
      const regimenResult = await this.conn.fetchRegimens(regimenId);
      this.regimen = regimenResult[0];
      this.voiceNoteBannerDetails.regimenCoverImageUrl = regimenResult[0]?.regimenCoverImage;
    } else {
      this.voiceNoteBannerDetails.regimenCoverImageUrl = undefined;
    }
  }

  async onAudioPlay(): Promise<void> {
    if (this.notListenedVoiceMessage?.get('trackingDetails')?.audioPlayed) return;
    const voiceNote = this.eventLogger.getEventNameBasedOnQuestionId(this.notListenedVoiceMessage?.get('questionId'));
    this.eventLogger.cleverTapEvent('audioPlayed',
      JSON.stringify({ orderChatId: this.notListenedVoiceMessage.id,
        pageName: 'home',
        voiceNote,
        questionId: this.notListenedVoiceMessage?.get('questionId') || 'undefined'
      }),
      [
        this.appConfig.Shared.EventTracker.MIXPANEL,
        this.appConfig.Shared.EventTracker.AMPLITUDE,
        this.appConfig.Shared.EventTracker.CLEVER_TAP,
        this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
      ]
    );
    await this.conn.trackVoiceNotesAndScrollEvents({ objectId: this.notListenedVoiceMessage.id,
      eventName: 'audioPlayed',
      trackingTable: 'orderChat' });
  }

  async onAudioPlayEnd(): Promise<void> {
    if (this.notListenedVoiceMessage?.get('trackingDetails')) {
      this.notListenedVoiceMessage.get('trackingDetails').audioPlayed = true;
    }
    this.eventLogger.cleverTapEvent('audioFinished', JSON.stringify({ orderChatId: this.notListenedVoiceMessage.id, pageName: 'home' }), [
      this.appConfig.Shared.EventTracker.MIXPANEL,
      this.appConfig.Shared.EventTracker.AMPLITUDE,
      this.appConfig.Shared.EventTracker.CLEVER_TAP,
      this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
    ]);
    await this.conn.trackVoiceNotesAndScrollEvents({ objectId: this.notListenedVoiceMessage.id,
      eventName: 'audioFinished',
      trackingTable: 'orderChat' });
  }

  async startFollowUp(event?: string): Promise<void> {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ pageName: 'sticky-bar-followUp' }));
    if (event) {
      this.trackEvent(event);
    }
    try {
      let followUpId = this.followUp().id;
      if (this.followUp()?.get('State') !== this.appConfig.Shared.Followup.State.WAITING_FOR_IMAGE) {
        const response = await this.conn.createFollowUp();
        followUpId = response?.followUpId || followUpId;
      }
      await this.router.navigate([`/chatV2/${followUpId}`], {
        queryParams: { type: 'followUp' },
      });
    } catch ({ message }) {
      this.broadcast.broadcast('NOTIFY', { message });
    }
  }

  onCancelClick(event?: any): void {
    if (event) event.stopPropagation();
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ pageName: 'sticky-bar-cancel-click' }));
    this.store.dispatch(fromActions.HomePageUpdate({ isSessionOn: false }));
  }

  /*
  Block that can be compartmentalized
  */
  goToCartNav(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ pageName: 'sticky-bar-cart-click' }));
    this.router.navigate(['cart']);
  }
  openBogoBanner(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'bogo-banner-click' }));
    const pageName = 'bogoProduct';
    this.conn.navigateToURL(`/user/order/reorder?from=${pageName}`);
  }
  openAovBanner(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'aov-banner-click' }));
    this.router.navigate(['/user'], { queryParams: { tab: 'shop', back: 'home' } });
  }
  openSaleBanner(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'sale-banner-click' }));
    this.router.navigate(['/user'], { queryParams: { tab: 'shop', back: 'home' } });
  }
  openShopPage(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'home-cash-banner-click' }));
    this.router.navigate(['/user'], { queryParams: { tab: 'shop', back: 'home' } });
  }
  redirectToTestimonialsPage(): void {
    this.router.navigate(['/user/testimonialsNew']);
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'testimonials-new-more' }));
  }
  checkoutOrder(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ pageName: 'sticky-bar-checkout' }));
    void this.router.navigate([`/user/order/${this.order?.objectId}/payment`]);
  }
  // End of compartment

  async viewTicket(): Promise<void> {
    await this.router.navigate([`/support/ticket/${this.supportTicket.objectId}`],
      { queryParams: { username: this.user?.get('username') } });
  }

  async fetchFeedback(): Promise<void> {
    if (this.skipExecutionForUnpaidUser) return;
    [this.feedback] = await this.conn.fetchFeedback({
      where: {
        user: this.user,
        type: this.appConfig.Shared.Feedback.Type.NPS,
        stage: [this.appConfig.Shared.Feedback.Stage.Created, this.appConfig.Shared.Feedback.Stage.Partial],
      },
      descending: 'createdAt',
      limit: 1,
    });
  }

  async openFeedback(): Promise<void> {
    this.eventLogger.trackEvent('NPS_BANNER_CLICKED', { id: this.feedback?.id });
    await this.router.navigate(['/feedback'], { queryParams: { feedbackId: this.feedback?.id } });
  }

  addEvents(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'order-status-banner' }));
  }

  openInstructions(cardNumber: string): void {
    const removedEventCards = ['card1', 'card2', 'card3', 'card5'];
    const channels = removedEventCards?.includes(cardNumber) ? [
      this.appConfig.Shared.EventTracker.CLEVER_TAP,
      this.appConfig.Shared.EventTracker.MOENGAGE,
      this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
    ] : []
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: `post-purchase-see-instructions-${cardNumber}`}), channels);
    if (this.latestPlacedRegimenOrder || this.faceRegimenOrderDelivered) {
      this.router.navigate(['/user'],
        { queryParams: { class: this.appConfig.Shared.Regimen.Class.FACE,
          username: this.user?.get('username'),
          tab: 'regimen',
          instructions: true } });
    }
  }

  openHelp(eventName?: string): void {
    const removedEvents = ['post-purchase-help-card-1'];
    const channels = removedEvents?.includes(eventName) ? [
      this.appConfig.Shared.EventTracker.CLEVER_TAP,
      this.appConfig.Shared.EventTracker.MOENGAGE,
      this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
    ] : [];
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: eventName }), channels);
    this.router.navigate(['/support']);
  }

  openCheckup(eventName?: string): void {
    const removedEvents = ['post-purchase-checkup-card-4', 'post-purchase-checkup-card-2']
    const channels = removedEvents?.includes(eventName) ? [
      this.appConfig.Shared.EventTracker.CLEVER_TAP,
      this.appConfig.Shared.EventTracker.MOENGAGE,
      this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
    ] : [];
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: eventName }), channels);
    this.router.navigate(['/user/checkup']);
  }

  openStaticArticle(articleID: string, eventName?: string): void {
    const removedEvents = [
      'post-purchase-sunscreen-card-5',
      'post-purchase-improv-card-5',
      'post-purchase-improv-card-3',
      'post-purchase-issue-card-2',
      'post-purchase-overdo-card-3',
    ];
    const channels = removedEvents?.includes(eventName) ? [
      this.appConfig.Shared.EventTracker.CLEVER_TAP,
      this.appConfig.Shared.EventTracker.MOENGAGE,
      this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
    ] : [];
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: eventName }), channels);
    this.navigateTo(`/article/${articleID}`);
  }

  openDoctorList(): void {
    this.navigateTo('/doctors');
  }

  openPopUp(type:string):void {
    this.bottomSheet.open(HomePageSheetComponent, {
      data: {
        popUpType: type,
      },
    });
  }

  async loadIncompleteChatBannerData(): Promise<void> {
    this.faceChatStartedAt = null;
    this.hairChatStartedAt = null;
    const payload: RequestQueryPayload<Table.ConsultationSession> = {
      where: {
        user: this.user,
        PrivateMainConcern: { $exists: true },
        PrivateMainConcernClass: { $nin: this.regimensClass || [] },
        archive: false,
        regimen: { $exists: false },
      },
      descending: 'updatedAt',
    };

    const consultationSessions = await this.conn.fetchConsultationSessions(payload);
    if (!consultationSessions) return;
    this.consultationSessionService.setConsultations(consultationSessions);

    const handleConcern = async (session: any, concernClass: any): Promise<void> => {
      const concern = session?.get('PrivateMainConcern');
      const serverConcerns = await this.conn.findMainWithSecondaryConcerns({
        concernClass,
        shouldTranslateConcernsList: true,
      });

      const matchedConcern = serverConcerns.find((data: any): boolean => data.value === concern);
      if (matchedConcern) {
        if (concernClass === 'HAIR') {
          this.hairDisplayConcern = matchedConcern.displayName;
          this.isHairChatPending = true;
          this.hairChatStartedAt = this.toTimestamp(session?.get('createdAt'));
        } else if (concernClass === 'FACE') {
          this.faceDisplayConcern = matchedConcern.displayName;
          this.isFaceChatPending = true;
          this.faceChatStartedAt = this.toTimestamp(session?.get('createdAt'));
        }
      }
    };

    // eslint-disable-next-line no-restricted-syntax
    for (const session of consultationSessions) {
      const concernClass = session?.get('PrivateMainConcernClass');
      if (concernClass === 'HAIR') {
        this.hairChatId = session.id;
        // eslint-disable-next-line no-await-in-loop
        await handleConcern(session, concernClass);
      }
      if (concernClass === 'FACE') {
        this.faceChatId = session.id;
        // eslint-disable-next-line no-await-in-loop
        await handleConcern(session, concernClass);
      }
    }

    const [consultationSession] = consultationSessions;
    if (!consultationSession) return;
    this.consultationSession = consultationSession;
    this.concernClass = this.consultationSession?.get('PrivateMainConcernClass');
    this.checkConsultationPopup();
  }

  private async loadIncompleteChatBannerPhotos(): Promise<void> {
    const pendingClasses: IncompleteChatClass[] = [];
    if (this.isFaceChatPending) pendingClasses.push(GetMainUserPhotosRegimenClassEnum.FACE);
    if (this.isHairChatPending) pendingClasses.push(GetMainUserPhotosRegimenClassEnum.HAIR);
    await this.incompleteChatBannerService.loadPhotos(pendingClasses);
  }

  isIncompleteChatRebranded(regimenClass: IncompleteChatClass): boolean {
    return this.incompleteChatBannerService.isRebranded(regimenClass);
  }

  private isCompleteProfileBannerAllowedForUser(): boolean {
    const isRetentionUser = this.userService.isPaidUser(this.user);
    if (!isRetentionUser) return true;

    return this.experimentService.isRetentionHomeRevampExperimentEnabled
      && this.isWithinFirstRegimenDeliveryWindow(this.COMPLETE_YOUR_PROFILE_BANNER_VISIBILITY_DAYS);
  }

  async loadCompleteYourProfileSection(): Promise<void> {
    this.completeProfileSections = [];
    this.completeProfileEventData = { completed: [], pending: [] };
    this.showCompleteYourProfileBanner = false;
    this.showRebrandedProfileBanner = false;
    this.rebrandedProfileCards = [];
    this.rebrandedProfilePosition = CompleteProfilePosition.BOTTOM;
    if (!this.isCompleteProfileBannerAllowedForUser()) return;

    const username = this.user.get('username');
    const profileClasses = this.completeYourProfileService.getProfileClasses();
    const checkupsByClass = await this.instantCheckupService.getCheckupsForClasses(username, profileClasses);
    const sections = profileClasses.map((regimenClass: RegimenClass): CompleteProfileSection => ({
      regimenClass,
      checkupsByType: checkupsByClass[regimenClass] ?? {},
    }));
    const contexts = profileClasses.map((regimenClass: RegimenClass): CompleteProfileClassContext =>
      this.buildCompleteProfileContext(regimenClass));
    const decision: CompleteProfileDecision = this.completeYourProfileService.decide(sections, contexts);

    if (decision.banner === CompleteProfileBanner.REBRANDED) {
      this.rebrandedProfileCards = decision.cards;
      this.rebrandedProfilePosition = decision.position;
      this.showRebrandedProfileBanner = true;
      return;
    }
    if (decision.banner !== CompleteProfileBanner.PROFILE) return;

    this.completeProfileSections = decision.sections;
    const completed: string[] = [];
    const pending: string[] = [];
    this.completeProfileSections.forEach((section: CompleteProfileSection): void => {
      Object.entries(section.checkupsByType).forEach(([type, checkup]: [string, InstantCheckup | null]): void => {
        (checkup ? completed : pending).push(type);
      });
    });
    this.completeProfileEventData = { completed, pending };
    this.showCompleteYourProfileBanner = true;
  }

  private buildCompleteProfileContext(regimenClass: RegimenClass): CompleteProfileClassContext {
    const isFace = regimenClass === ApiClientConstant.Regimen.Class.FACE;
    const regimen = this.regimens?.find((each: AllocatedRegimen): boolean => each?.class === regimenClass);
    return {
      regimenClass,
      isChatPending: isFace ? this.isFaceChatPending : this.isHairChatPending,
      chatStartedAt: isFace ? this.faceChatStartedAt : this.hairChatStartedAt,
      hasRegimen: !!regimen,
      regimenCreatedAt: this.toTimestamp(regimen?.createdAt),
    };
  }

  private toTimestamp(value?: string | Date | null): number | null {
    if (!value) return null;
    const time = new Date(value).getTime();
    return Number.isNaN(time) ? null : time;
  }

  async openChatFromNewIncompleteChatBanner(event: any): Promise<void> {
    const targetElement: HTMLElement = event.currentTarget as HTMLElement;
    const { id }: { id: string } = targetElement;
    const selectedClass = id.includes('face') ? GetMainUserPhotosRegimenClassEnum.FACE : GetMainUserPhotosRegimenClassEnum.HAIR;
    this.eventLogger.cleverTapEvent('click', JSON.stringify({
      name: 'chat_incomplete_carousel_banner_clicked',
      isRebrandedV2: this.isIncompleteChatRebranded(selectedClass),
    }));
    if (id.includes('face')) {
      try {
        await this.conn.switchUserToState(
          `v4_${this.appConfig.Shared.Regimen.Class.FACE.toLowerCase()}:`,
          { consultationSessionId: this.faceChatId });
      } catch(error) {
        this.eventLogger.trackEvent('ERROR_switchUserToState', { error: error, consultationSessionId: this.faceChatId, from:'incomplete-chat-banner' });
      }

      await this.router.navigate(['/user'], {
        queryParams: { tab: 'regimen', class: this.appConfig.Shared.Regimen.Class.FACE }
      });
    } else if (id.includes('hair')) {
      try {
        await this.conn.switchUserToState(
          `v4_${this.appConfig.Shared.Regimen.Class.HAIR.toLowerCase()}:`,
          { consultationSessionId: this.hairChatId });
      } catch(error) {
        this.eventLogger.trackEvent('ERROR_switchUserToState', { error: error, consultationSessionId: this.hairChatId, from:'incomplete-chat-banner' });
      }
      await this.router.navigate(['/user'], {
        queryParams: { tab: 'regimen', class: this.appConfig.Shared.Regimen.Class.HAIR }
      });
    }
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    if (this.bottomSheetTimer) {
      clearTimeout(this.bottomSheetTimer);
      this.bottomSheetTimer = null;
    }
    this.subscriptions.forEach((subscription: Subscription): void => subscription.unsubscribe());
    this.subscriptions = [];
    this.currentComponentService.remove(this);
  }

  async trackEventOne(action: any): Promise<void> {
    switch (action) {
      case 'play': {
        await this.onAudioPlayCart();
        break;
      }
      case 'completed': {
        await this.onAudioPlayEndCart();
        break;
      }
      default:
    }
  }

  async onAudioPlayCart(): Promise<void> {
    const voiceNote = this.shouldSendVoiceNoteName() ? 'product-added-by-script-voice-note' : 'undefined';
    this.eventLogger.cleverTapEvent('audioPlayed', JSON.stringify({ followupReportId: this.user.id, pageName: 'home', voiceNote }), [
      this.appConfig.Shared.EventTracker.MIXPANEL,
      this.appConfig.Shared.EventTracker.AMPLITUDE,
      this.appConfig.Shared.EventTracker.CLEVER_TAP,
      this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
    ]);
  }

  private shouldSendVoiceNoteName(): boolean {
    return this.productAddedByScript?.isDoctorAdded && this.productAddedByScript?.isAddedByScript && this.productAddedByScript?.scriptAudioUrl;
  }

  async onAudioPlayEndCart(): Promise<void> {
    this.eventLogger.cleverTapEvent('audioFinished', JSON.stringify({ userId: this.user.id, pageName: 'home' }), [
      this.appConfig.Shared.EventTracker.MIXPANEL,
      this.appConfig.Shared.EventTracker.AMPLITUDE,
      this.appConfig.Shared.EventTracker.CLEVER_TAP,
      this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
    ]);
  }

  async addProductToCart(product: any): Promise<void> {
    const isProductInCart = this.cartItems.some(
      (product: any): any => product.productId === this.recommendedItems[0].productId);
    if (!isProductInCart) {
      const params = {
        productId: product.productId,
        quantity: 1,
      };
      await this.conn.addProductToCart(params);
    }
    this.conn.navigateToURL('/cart');
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'add-to-cart-recommended-product' }));
  }

  regimenOfferProduct(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'free_travel_pouch_clicked_homepage' }));
    if (this.latestUnBoughtRegimen || this.latestUnDelivereRegimen) {
      this.buyRegimen(this.latestUnBoughtRegimen?.class || this.latestUnDelivereRegimen?.class);
    } else if (this.consultationSession) this.openConsultation();
  }

  handleCompleteOrderBannerVisibility(isIntersecting: boolean): void {
    this.shouldShowStickyWidget = !isIntersecting;
    this.changeDetectorRef.detectChanges();
  }

  getRecentActiveNutraOrders(cancelledStages: any[], ninetyDaysAgo: Date, nutraMargIds: string[]): Array<Table.Order> {
    const userActiveOrders = this.userActiveOrders();
    if (userActiveOrders.length === 0) {
      return [];
    }

    const filteredOrders = userActiveOrders.filter(order => {
      const orderStage = order.get('stage');
      const orderCreatedAt = order.get('createdAt');
      const orderProductInfo: Table.Order['attributes']['productInfo'] = order.get('productInfo');

      // Check if order stage is not in cancelled stages
      const isNotCancelled = !cancelledStages.includes(orderStage);

      // Check if order was created within last 90 days
      const isWithin90Days = new Date(orderCreatedAt) >= ninetyDaysAgo;

      // Check if order has products with nutra margIds
      const hasNutraProducts = orderProductInfo?.some((product: Table.Order['attributes']['productInfo'][number]) =>
        nutraMargIds.includes(product.margId)
      );

      return isNotCancelled && isWithin90Days && hasNutraProducts;
    });

    return filteredOrders;
  }

  async getActiveAndCompletedOrders(): Promise<void> {
    const constants = this.getBannerTimingConstants();
    const nutraMargIds = Object.keys(this.nutraProductsInfo || {});
    const cancelledStages = [...this.appConfig.Shared.Order.Stage.orderCanceledStages, this.appConfig.Shared.Order.Stage.REFUND_REQUESTED];
    const ninetyDaysAgo = this.timeService.removeDays(new Date(), 90);
    ninetyDaysAgo.setUTCHours(23, 59, 59, 999);
    const result = this.getRecentActiveNutraOrders(cancelledStages, ninetyDaysAgo, nutraMargIds);
    const orders = JSON.parse(JSON.stringify(result));
    const deliveredOrders = orders.filter((order) => order.stage === 'DELIVERED');
    const notIncludedOrderStages = ['DELIVERED', 'INITIAL', 'ONLINE_PAYMENT_PENDING']
    const nonDeliveredOrderProducts = orders
      .filter(order => !notIncludedOrderStages.includes(order.stage))
      .flatMap(order => order.products);
    const highestPackSizeMap = this.buildHighestPackSizeMap(deliveredOrders || [], nutraMargIds, constants);
    // Filter banners based on display date criteria
    const today = new Date();
    this.nutraBannerData = Object.values(highestPackSizeMap).filter(banner => {
      const displayFrom = new Date(banner.displayFrom);
      const displayTill = new Date(banner.displayTill);
      const isWithinDateRange = today >= displayFrom && today <= displayTill;

      // Opposite: only include if NO product has the same margId
      const isNotInNonDelivered = !nonDeliveredOrderProducts.some(product => product.margId === banner.margId);

      return isWithinDateRange && isNotInNonDelivered;
    });
  }

  getBannerTimingConstants() {
    const displayDays = this.nutraBannerExperimentVariantData?.variant?.displayDays || {};

    const DISPLAY_DURATION_DAYS = displayDays?.displayDurationDays;
    const START_DAY_PACK_OF_1 = displayDays?.startDayPackOfOne;
    const START_DAY_PACK_OF_2 = displayDays?.startDayPackOfTwo;
    const START_DAY_PACK_OF_3 = displayDays?.startDayPackOfThree;

    return {
      DISPLAY_DURATION_DAYS,
      START_DAY_PACK_OF_1,
      START_DAY_PACK_OF_2,
      START_DAY_PACK_OF_3,
    };
  }

  buildOrderQuery(nutraMargIds: string[]) {
    const cancelledStages: any[] = [
      this.appConfig.Shared.Order.Stage.CANCELED,
      this.appConfig.Shared.Order.Stage.RETURNED,
      this.appConfig.Shared.Order.Stage.REFUND_PROCESSED,
      this.appConfig.Shared.Order.Stage.LOST_IN_TRANSIT,
      this.appConfig.Shared.Order.Stage.NONSERVICEABLEAREA,
      this.appConfig.Shared.Order.Stage.COURIER_NOT_AVAILABLE,
      this.appConfig.Shared.Order.Stage.RETURN_INITIATED,
      this.appConfig.Shared.Order.Stage.RETURN_REQUESTED,
      this.appConfig.Shared.Order.Stage.REFUND_REQUESTED,
      this.appConfig.Shared.Order.Stage.BOT_CANCELED,
      this.appConfig.Shared.Order.Stage.REFUND_INITIATED,
    ];

    const ninetyDaysAgo = this.timeService.removeDays(new Date(), 90);
    ninetyDaysAgo.setUTCHours(23, 59, 59, 999);
    return {
      user: this.user,
      stage: { $nin: cancelledStages },
      'productInfo.margId': { $in: nutraMargIds },
      createdAt: { $gte: ninetyDaysAgo }
    };
  }

  buildHighestPackSizeMap(
    orders: any[],
    nutraMargIds: string[],
    constants: {
      DISPLAY_DURATION_DAYS: number,
      START_DAY_PACK_OF_1: number,
      START_DAY_PACK_OF_2: number,
      START_DAY_PACK_OF_3: number
    }
  ) {
    const map: Record<string, any> = {};

    // Sort orders by deliveredOn date in descending order (latest first)
    const sortedOrders = [...orders].sort((a, b) =>
      new Date(b.deliveredOn).getTime() - new Date(a.deliveredOn).getTime()
    );

    sortedOrders.forEach(order => {
      const validProducts = this.extractValidProducts(order, nutraMargIds);

      validProducts.forEach(({ margId, packSize, product }) => {
        // Only update the map if:
        // 1. This margId hasn't been seen before, OR
        // 2. This order is more recent than the existing entry
        const existingEntry = map[margId];
        const isNewerDelivery = !existingEntry ||
          new Date(order.deliveredOn) > new Date(existingEntry.deliveredOn);

        if (isNewerDelivery) {
          map[margId] = this.createBannerEntry(margId, packSize, product, order.deliveredOn, constants);
        }
      });
    });

    return map;
  }

  extractValidProducts(order: any, nutraMargIds: string[]) {
    return (order.products || [])
      .filter(product => nutraMargIds.includes(product.margId))
      .map(product => ({
        margId: product.margId,
        packSize: product.margUnit,
        product
      }));
  }

  createBannerEntry(
    margId: string,
    packSize: number,
    product: any,
    deliveredOn: Date,
    constants: {
      DISPLAY_DURATION_DAYS: number,
      START_DAY_PACK_OF_1: number,
      START_DAY_PACK_OF_2: number,
      START_DAY_PACK_OF_3: number
    }
  ) {
    const {
      START_DAY_PACK_OF_1,
      START_DAY_PACK_OF_2,
      START_DAY_PACK_OF_3,
      DISPLAY_DURATION_DAYS
    } = constants;

    const startDays = { 1: START_DAY_PACK_OF_1, 2: START_DAY_PACK_OF_2, 3: START_DAY_PACK_OF_3 }[packSize] || START_DAY_PACK_OF_1;

    const displayFrom = this.timeService.addDays(new Date(deliveredOn), startDays);
    const displayTill = this.timeService.addDays(displayFrom, DISPLAY_DURATION_DAYS);
    const productInfo = this.nutraProductsInfo[margId];

    return {
      margId,
      packSize,
      title: product?.title,
      bannerImage: productInfo?.bannerImage,
      deliveredOn,
      displayFrom: displayFrom.toISOString(),
      displayTill: displayTill.toISOString()
    };
  }


  checkIfNutraBannerNeedToRender(): void {
    this.showNutraBanner = (this.nutraBannerData?.length > 0);
  }

  async openVariantsPopup(margId: string): Promise<void> {
    this.eventLogger.cleverTapEvent('HP_nutra_repeat_banner_clicked', JSON.stringify({ Nutra_type: this.nutraProductsInfo[margId]?.title }));
    await this.getCart();
    const variants = await this.fetchProductsByMargId(margId);
    if (!variants?.length) return;

    const product = variants[0];
    this.cartService.openVariantsPopup(product, variants, this.cartItems, 'nutra_repeat_banner');
  }

  async fetchProductsByMargId(margId: string): Promise<any> {
    return await this.conn.findProducts(
      { margId },
      ['margId', 'margUnit', 'title', 'mrp', 'price', 'quantity', 'quantityUnit', 'objectId', 'prescriptionRequired', 'rebrandedImageWithBackground']
    );
  }

  async addOrRemoveProductFromVariantsPopup(productId: any, action: string): Promise<void> {
    try {
      const params = {
        productId,
        quantity: 1,
        userId: this.user.id,
      };

      if (action === 'ADD') {
        await this.conn.addProductToCart(params);
      } else {
        await this.conn.serverApi.removeProductFromCart(params, this.user.get('sessionToken'));
      }

      await this.getCart();
    } catch (error: any) {
      const errorMessage = error.message || `Failed to ${action.toLowerCase()} product to cart`;
      this.broadcast.broadcast('NOTIFY', { message: errorMessage });
    }
  }

  closeBottomSheet(): void {
    this.bottomSheet.dismiss();
  }

  handleVariantsPopupProceedToBuy(productTitle: string): void {
    this.closeBottomSheet();

    const ctaType = this.buyNowFlowExperiment
      ? 'variants_popup_proceed_to_buy_direct'
      : 'variants_popup_proceed_to_buy_cart_redirect';

    const eventPayload: any = {
      cta: ctaType,
      product_title: productTitle
    };

    if (this.buyNowFlowExperiment) {
      const productsToBuy =
        this.activeNutraBannerData.variantData
          ?.filter(v => v.cartQuantity > 0)
          ?.flatMap(v => Array(v.cartQuantity).fill(v.objectId)) || [];

      eventPayload.products_continued_to_buy = productsToBuy;

      this.eventLogger.cleverTapEvent('click', JSON.stringify(eventPayload));
      this.checkoutWithProductIds(productsToBuy);
    } else {
      this.eventLogger.cleverTapEvent('click', JSON.stringify(eventPayload));
      this.goToCart();
    }
  }

  checkoutWithProductIds(productsToBuy: string[]): void {
    const url = 'user/checkout';
    const orderState = this.user?.get('orderState');
    const queryParams = {
      type: this.appConfig.Shared.Order.Type.PRODUCT,
      products: productsToBuy.toString(),
      useCureSkinCash: String(this.experimentService.shouldUseCureSkinCash(orderState))
    };
    this.router.navigate([url], { queryParams });
  }

  // Method to prepare cart data for recently-viewed-products component
  getCartDataForRecentlyViewed(): any {
    if (!this.cartItems || this.cartItems.length === 0) {
      return null;
    }

    return {
      cartItems: this.cartItems,
      totalSP: this.totalSP,
      totalMRP: this.totalMRP,
      discountPercentage: this.cartDiscount
    };
  }

  /**
   * Fetch recently viewed products data using the service
   * This method is called during the existing data loading process
   */
  async fetchRecentlyViewedProducts(): Promise<void> {
    try {
      const recentlyViewedExp = this.experimentService.getRecentlyViewedExperiment();
      if (recentlyViewedExp && !recentlyViewedExp.variant?.HOME) {
        this.recentlyViewedData = [];
        this.shouldShowRecentlyViewedSection = false;
        return;
      }

      const data = await this.recentlyViewedProductsService.getRecentlyViewedData(
        RecentlyViewedEnum.Location.HOME,
        false
      );

      if (data?.shouldShowComponent) {
        this.recentlyViewedData = data.items;
        this.shouldShowRecentlyViewedSection = true;
      } else {
        this.recentlyViewedData = [];
        this.shouldShowRecentlyViewedSection = false;
      }
    } catch (error) {
      console.error('Error fetching recently viewed products in user-home:', error);
      this.recentlyViewedData = [];
      this.shouldShowRecentlyViewedSection = false;
    }
  }

  get shouldShowFollowUpDot(): boolean {
    return ['followUpScheduledInTwoDays', 'anyTimeFollowUpEnabled', 'lastFollowUpSkipped'].includes(this.selectedFollowUpBanner);
  }

  private isCartBannerVisibleOnHomepage(): boolean {
    if (!this.userStatus?.PAID) return false;

    const hasCartOrRecommendations =
      (this.productsInCart?.length ?? 0) > 0 || (this.recommendedItems?.length ?? 0) > 0;

    if (!hasCartOrRecommendations) return false;
    if (this.voiceNoteByScript) return true;
    if (this.showSuggestedForYouBanner) return true;
    return (this.productsInCart?.length ?? 0) >= 1;
  }

  get shouldShowShopNavigateBanner(): boolean {
    const isRetentionUser =
      this.user?.get('orderState') === this.appConfig.Shared.User.OrderState.DELIVERED;

    if (!isRetentionUser) return false;
    if (this.isWithinFirstRegimenDeliveryBlockWindow()) return false;

    const isBogoBannerVisible = !!(this.userStatus?.PAID && this.isBOGOSaleLive);
    const isAovBannerVisible = !!(isRetentionUser && this.isAovSaleLive);
    const isRecentlyViewedBannerVisible = !!this.shouldShowRecentlyViewedSection;
    const isCartBannerVisible = this.isCartBannerVisibleOnHomepage();

    return !(isBogoBannerVisible || isAovBannerVisible || isRecentlyViewedBannerVisible || isCartBannerVisible);
  }

  get shouldShowRecommendedProductsSection(): boolean {
    if (!this.experimentService.recommendedProductsExperiment) return false;
    const daysSinceDelivery = this.regimenService.daysSinceLastActiveRegimenDelivered(this.regimens);
    return this.experimentService.isRecommendedProductsSectionVisible(this.user, RecommendedProductsSurface.Home, daysSinceDelivery);
  }

  async loadRecommendedProducts(): Promise<void> {
    if (!this.shouldShowRecommendedProductsSection) return;
    this.recommendedProducts = await this.recommendedProductsService.load();
  }

  get isRecommendedProductsShown(): boolean {
    return this.shouldShowRecommendedProductsSection && this.recommendedProducts.shouldShow;
  }

  get shouldRenderRecentlyViewed(): boolean {
    return this.shouldShowRecentlyViewedSection && !this.isRecommendedProductsShown;
  }

  setRestockBannerVisible(visible: boolean): void {
    this.isRestockBannerVisible.set(visible);
    if (visible) this.elementPositionService.scan(this.trackableDirectives);
  }

  private async loadLanguageBannerContent(): Promise<void> {
    this.languageBannerContent.set(await this.languageBannerService.buildLanguageBannerContent());
  }

  private isWithinFirstRegimenDeliveryBlockWindow(): boolean {
    return this.isWithinFirstRegimenDeliveryWindow(this.SHOP_BANNER_BLOCK_DAYS);
  }

  private isWithinFirstRegimenDeliveryWindow(days: number): boolean {
    const firstOrder: Table.Order | null = this.orderService.getFirstDeliveredRegimenOrder(this.allActiveOrders);
    if (!firstOrder) return false;
    return this.orderService.getDaysSinceDelivered(firstOrder) < days;
  }

  async checkIfNotificationBannerNeedsToBeDisplayed(): Promise<void> {
    try {
      await this.handleNotificationPermissions();

    } catch (error) {
      this.showNotificationBanner = false;
      this.isNotificationPermissionEnabled = false;
      console.error('Error in checkIfNotificationBannerNeedsToBeDisplayed:', error);
    }
  }

  private async handleNotificationPermissions(): Promise<void> {
    // Get current permission status from Android
    const notificationPermissionStatusFromAndroid = await this.appBridge.requestNotificationStatus() ?? false;
    this.isNotificationPermissionEnabled = notificationPermissionStatusFromAndroid;

    // Get status from DB for sync check
    const notificationPermissionStatusFromDB = await this.conn.showNotificationPermissionPopup();
    const hasPermissionInDB = !!notificationPermissionStatusFromDB?.notificationAllowedAt;

    // Only update DB if Android permissions changed
    if (notificationPermissionStatusFromAndroid !== hasPermissionInDB &&
        notificationPermissionStatusFromAndroid) {  // Only sync when permissions are granted
      this.handlePermissionAction(notificationPermissionStatusFromAndroid);
    }

    const todayDate: string = new Date().toISOString().split('T')[0];

    // Set banner visibility based on permission status
    if (!this.isNotificationPermissionEnabled && (todayDate !== this.localStorageService.getValue('notificationBannerDisabledDate'))) {
      this.showNotificationBanner = true;
    } else if (this.isNotificationPermissionEnabled) {
      this.showNotificationBanner = false;
      this.localStorageService.delete('notificationBannerDisabledDate')
    }
  }

  closeNotificationBanner(): void {
    const todayDate: string = new Date().toISOString().split('T')[0];
    this.showNotificationBanner = false;
    this.localStorageService.setValue('notificationBannerDisabledDate', todayDate);
  }

  openNativePermissionPopup(): void {
    this.appBridge.requestNotificationPermission();
    this.showNotificationBanner = false;
  }

  handlePermissionAction(isEnable: boolean): void {
    if (isEnable) {
      this.openNativePermissionPopup();
    } else {
      this.closeNotificationBanner();
    }
  }

  async respondPermissionBanner(isEnable: boolean): Promise<void> {
    const eventName = isEnable ? 'enabled' : 'disabled';
    try {
      this.handlePermissionAction(isEnable);
      this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: `notifications_${eventName}_HP_Banner` }));
    } catch (error) {
      this.broadcast.broadcast('NOTIFY', { message: 'Failed to save notification preference' });
    }
  }


  // NUTRA PUSH BANNER
  async handleNutraPushExperiment(experiment): Promise<void> {
    this.nutraPushExperiment = true;
    this.nutraPushExperimentVariantData = experiment.variant;
  }

  async getNutraPushData(): Promise<void> {
    if (this.skipExecutionForUnpaidUser) return;
    if (this.nutraPushExperiment && this.nutraPushExperimentVariantData ){
      const progressiveInfoData = await this.conn.getActiveProgressiveTreatmentOfUser();
      if(progressiveInfoData?.progressiveTreatments?.length > 0) {  // <-- Fixed condition
        const nutraProductId = progressiveInfoData.progressiveTreatments[0].product?.objectId;
        const nutraMargId = progressiveInfoData.progressiveTreatments[0].product?.margId;
        if (nutraProductId) {  // <-- Only call findProductsById if we have a product ID
          const catalogRes = await this.conn.findProductsById(nutraProductId, ['heroIngredients', 'productHighlights']);
          this.nutraPushBannerData = this.nutraPushExperimentVariantData?.nutraProductsData[nutraMargId];
          this.nutraPushBottomSheetData = JSON.parse(JSON.stringify(catalogRes))[0];
        }
      }
    }
  }

  navigateToReAcquisitionFlow(bannerType: ReAcquisitionBannerType): void {
    this.reAcquisitionService.navigateToReAcquisitionFlow(bannerType, this.user);
  }

  async shouldShowRegimenExpiryBanner(): Promise<void> {
    if (this.skipExecutionForUnpaidUser) return;
    const result = await this.regimenExpiryService.shouldShowRegimenExpiryBanner({
      user: this.user,
      regimenExpiryExperiment: this.regimenExpiryExperiment,
      allocatedDoctor: this.allocatedDoctor,
      defaultDoctorImage: this.defaultDoctorImage
    });
    this.showRegimenExpiryBanner = result.showBanner;
    this.regimenExpiryBannerData = result.bannerData;
    if (this.showRegimenExpiryBanner && !!result?.userDrImage ){
      this.userDrImage = result?.userDrImage;
    }
    if (this.showRegimenExpiryBanner) {
      this.regimenExpiryEventData = {
        regimenClass: this.regimenExpiryService.getRegimenClass(this.regimenExpiryBannerData.products),
        redirectToFollowUp: this.regimenExpiryBannerData?.redirectToFollowUp?.toString(),
        daysToExpire: this.regimenExpiryBannerData?.regimenExpireIn?.toString(),
      };
    }
  }

  async handleRegimenExpiryBannerClick(): Promise<void> {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'HP_regimen_will_expire' }));
    this.regimenExpiryService.handleRegimenExpiryBannerClick(this.regimenExpiryBannerData, this.user, this.userDrImage, RegimenExpiryBottomsheetComponent);
  }

  get isRegimenExpired(): boolean {
    return this.regimenExpiryService.shouldShowRegimenExpiredBanner({
      regimens: this.regimens,
      totalAmountSpent: this.user.get('totalAmountSpent'),
      isPaidUser: this.userStatus.PAID,
      consultationSession: undefined,
      skipHide: true
    });
  }

  hideRegimenExpiredBanner(): void {
    this.showRegimenExpiredBanner = false;
  }

  // Helper methods for Weekly Journey data
  getWeeklyJourneyData(type: WeeklyJourneyType): WeeklyJourneyData {
    return {
      type,
      user: this.user,
      latestPlacedRegimenOrder: this.latestPlacedRegimenOrder,
      allocatedDoctor: this.allocatedDoctor,
      defaultDoctorImage: this.defaultDoctorImage,
      primaryConcern: this.primaryConcern,
      otherConcerns: this.otherConcerns,
      pendingCheckInCall: this.pendingCheckInCall,
      faceRegimenOrderDelivered: this.faceRegimenOrderDelivered,
      latestFaceRegimenDelivered: this.latestFaceRegimenDelivered,
      followUp: this.followUp(),
      weeklyJourneyVariant: this.weeklyJourneyVariant,
    };
  }

  isWeekVisible(journeyType: WeeklyJourneyType): boolean {
    if (!this.weeklyJourneyVariant) {
      return true; // Don't filter if weeklyJourneyVariant is not configured
    }

    const weekVisibility = this.weeklyJourneyVariant?.weekVisibility;
    if (!weekVisibility) {
      return true; // Don't filter if weekVisibility is not configured
    }

    // true if undefined or true, false only if explicitly false
    switch (journeyType) {
      case WeeklyJourneyType.WEEK_ZERO:
        return weekVisibility?.week0 !== false;
      case WeeklyJourneyType.WEEK_ONE_PART_ONE:
      case WeeklyJourneyType.WEEK_ONE_PART_TWO:
        return weekVisibility?.week1 !== false;
      case WeeklyJourneyType.WEEK_TWO_PART_ONE:
      case WeeklyJourneyType.WEEK_TWO_PART_TWO:
        return weekVisibility?.week2 !== false;
      case WeeklyJourneyType.WEEK_THREE:
        return weekVisibility?.week3 !== false;
      case WeeklyJourneyType.WEEK_FOUR:
        return weekVisibility?.week4 !== false;
      default:
        return true;
    }
  }

  sendClickEventFromOldWeeklyJourney(ctaId: string): void {
    const eventData = {
      name: ctaId,
      version: 0,
    }
    this.eventLogger.cleverTapEvent('click', JSON.stringify(eventData));
  }

  private findLatestDeliveredRegimenOrder(): Table.Order {
    const activeOrders = this.userActiveOrders();
    const sortedOrders = this.orderHelper.sortOrdersByDeliveredOn(activeOrders);
    const regimenOrders = this.orderHelper.filterOrdersByType(sortedOrders, this.appConfig.Shared.Order.Type.REGIMEN);
    return regimenOrders[0];
  }

  validateAndUpdateBentoGridCards(): void {
    if (!this.experimentService.isRetentionHomeRevampExperimentEnabled) {
      return;
    }
    const retentionRevampCardTypes = [HomepageInfoCardType.KNOW_ABOUT_DOCTORS, HomepageInfoCardType.CLINICAL_TECHNOLOGY];
    this.bentoGridCards = retentionRevampCardTypes
      .map((cardType: HomepageInfoCardType) => this.bentoGridCards.find((card: HomepageInfoCard) => card.type === cardType))
      .filter((card: HomepageInfoCard | undefined): card is HomepageInfoCard => !!card)
      .map((card: HomepageInfoCard) => ({
        ...card,
        ...RetentionRevampCardOverrides[card.type],
        colSpan: 1,
        customStyling: RetentionRevampCardStyling,
        bannerText: card.rebrandedBannerText ?? card.bannerText,
      }));
  }

  get isPaidUser(): boolean {
    return this.userService.isPaidUser(this.user);
  }

  get isRetentionHomeRevampExperimentEnabled() {
    return this.experimentService.isRetentionHomeRevampExperimentEnabled;
  }

  private get retHomepageRevampVariant() {
    return this.experimentService.getRetentionHomeRevampExperiment()?.variant;
  }

  get orderDeliveryPartialVideos(): boolean {
    return !!this.retHomepageRevampVariant?.order_delivery_banner_partial_videos;
  }

  get orderDeliveryBannerStartDay(): number {
    return this.retHomepageRevampVariant?.order_delivery_banner_start_day ?? ORDER_DELIVERY_BANNER.DEFAULT_START_DAY;
  }

  get orderDeliveryBannerEndDay(): number {
    return this.retHomepageRevampVariant?.order_delivery_banner_end_day ?? ORDER_DELIVERY_BANNER.DEFAULT_END_DAY;
  }

  get isRetentionHomeRevampActive(): boolean {
    return this.isRetentionHomeRevampExperimentEnabled && this.userStatus.PAID;
  }

  get showCompleteYourProfileTop(): boolean {
    return this.showCompleteYourProfileBanner && this.userService.isPaidUser(this.user);
  }

  get showCompleteYourProfileBottom(): boolean {
    return this.showCompleteYourProfileBanner && this.userService.isUnpaidUser(this.user);
  }

  get showRebrandedProfileTop(): boolean {
    return this.showRebrandedProfileBanner
      && this.rebrandedProfilePosition === CompleteProfilePosition.TOP;
  }

  get showRebrandedProfileBottom(): boolean {
    return this.showRebrandedProfileBanner
      && this.rebrandedProfilePosition === CompleteProfilePosition.BOTTOM;
  }

  get isCrossRegimenBannerEligible(): boolean {
    return !this.consultationSession && this.showNewCrossRegimenBanner;
  }

  get showCrossRegimenBannerTop(): boolean {
    return this.isCrossRegimenBannerEligible && !this.isRetentionHomeRevampActive;
  }

  get isOrderDeliveryBannerVisible(): boolean {
    return !!this.orderDeliveryVideoBannerOrders.length;
  }

  /**
   * Retention revamp: once the order-delivery banner has aged out (past
   * `order_delivery_banner_end_day`), the cross-sell banner moves up to sit right above
   * "complete your profile" instead of staying near the bottom of the page.
   */
  get showCrossRegimenBannerAboveProfile(): boolean {
    return this.isCrossRegimenBannerEligible && this.isRetentionHomeRevampActive && !this.isOrderDeliveryBannerVisible;
  }

  get showCrossRegimenBannerBottom(): boolean {
    return this.isCrossRegimenBannerEligible && this.isRetentionHomeRevampActive && this.isOrderDeliveryBannerVisible;
  }

  get showLastLevelBanner(): boolean {
    return !!this.lastLevelBannerOrder?.length && this.userStatus.PAID && !this.isRetentionHomeRevampActive;
  }

  get showBentoGrid(): boolean {
    return !!this.user && this.userService.isUnpaidUser(this.user);
  }

  private get isAnyProfileRequestBannerVisible(): boolean {
    return this.showCompleteYourProfileBanner || this.showRebrandedProfileBanner;
  }

  get showAnalysisBannerTop(): boolean {
    return !this.takePhotoBannerPositionBottom && !this.isRetentionHomeRevampActive && !this.isAnyProfileRequestBannerVisible;
  }

  get showAnalysisBannerBottom(): boolean {
    return this.takePhotoBannerPositionBottom && !this.isRetentionHomeRevampActive && !this.isAnyProfileRequestBannerVisible;
  }

  get orderStatusEventData(): { [key: string]: any } | undefined {
    if (!this.allActiveOrders?.length) {
      return undefined;
    }
    const hasPartialCancellationUI = this.allActiveOrders.some((order: any): boolean => {
      return this.orderService.shouldShowPartialOrderCancellationUIDeleteAfterRefactor(order);
    });
    return hasPartialCancellationUI ? { partialOrderCancellationUI: true } : undefined;
  }

  shouldSkipForUnpaidUser(): boolean {
    return this.isUnpaidUser;
  }

  get shouldShowTakePhotoBanner(): boolean {
    if (!this.isTakePhotoBannerEligible) return false;
    if (this.takePhotoBannerTrigerringStates.orderWaitingForImage) return true;
    return !this.isAnyProfileRequestBannerVisible;
  }

  get crossSellScrollBannerName(): string {
    return this.latestActiveRegimen?.class === this.appConfig.Shared.Regimen.Class.HAIR ? 'cross_sell_hair' : 'cross_sell_face';
  }

  protected readonly PRIMARY_CHANNELS = PRIMARY_CHANNELS;

  get daysSinceLatestRegimenDelivery(): number | null {
    const latestOrder = this.orderService.getLatestDeliveredRegimenOrder(this.allActiveOrders ?? []);
    if (!latestOrder) return null;
    return this.orderService.getDaysSinceDelivered(latestOrder);
  }

  get shouldShowInvestigationStrip(): boolean {
    if (!this.userStatus?.PAID) return false;
    if (!this.experimentService.isInvestigationBannerVisibleOnHome(this.daysSinceLatestRegimenDelivery)) return false;
    return !!this.investigationStatus?.isInvestigationAsked && !this.investigationStatus?.isReportUploaded;
  }

  onInvestigationStripClick(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'HP_investigation_strip' }));
    this.bottomSheet.open(InvestigationSheetComponent, {
      data: {
        investigationStatus: this.investigationStatus,
        doctorImage: this.userDrImage,
      },
    });
  }
}

export default UserHomeComponent;
